import moment from "moment";
import {
  api_request, answer_request
} from '@/utils/api';
import {
  isDEV, LocationOrigin, dict2params
} from "@/utils/request";
// let isDEV = false;
//新建对话
export const post_biogpt_chat = (rq, func)=>{
  // if(isDEV){
  //   func({
  //     "data": {
  //       "account": "hpp_test",
  //       "chat_name": "test",
  //       "chat_no": 1
  //     },
  //     "message": "success",
  //     "status": 1000001
  //   });
  //   return;
  // }
  api_request({
    type: 'post',
    url: '/api/v2/biogpt/chat/',
    data: rq,
    crud_name: '新建对话',
    success: func
  });
};
let short_answer_url = LocationOrigin + '/lins/short/answer/';
//lins问答
export const get_short_answer_stream = async (data, func)=>{
  // console.log(rq);
  // data.az = localStorage.getItem('access-token');
  let url = short_answer_url + '?' + dict2params(data);
  var source = new EventSource(url);
  // let references = [];
  // let n  = 0;
  source.onmessage = function(event) {
    const eventData = event.data;
    console.log('eventData', typeof eventData);
    try {
      const parseData = JSON.parse(eventData);
      // const {content, tag} = parseData;
      // console.log('content', content);
      func( parseData);
    }
    catch (e) {
      func({content: eventData});
      console.log('JSON.parse(eventData) error===', e);
    }
    // if (parsedData.url) {
    //     references = [...references, parsedData];
    //     console.log('References:', references);
    // }
    //
    // if (parsedData.answer) {
    //     const answer = parsedData.answer;
    //     // 答案输出是流式的，有多次返回
    //     // 遇到终止符时关闭sse连接
    //     if (answer.includes(endSign)){
    //         source.close();
    //     }
    //     if(func) func(answer, references, n);
    //     n ++;
    // }
  };
  source.onerror = function(error) {
    // Handle error
    console.log(error);
    // func('INTERNAL SERVER ERROR' + endSign);
    source.close();
  };
};
//lins问答
export const get_answer_stream = async (api_url, data, func)=>{
  // console.log(rq);
  data.az = localStorage.getItem('access-token');
  let url = LocationOrigin + api_url + '?' + dict2params(data);
  var source = new EventSource(url);
  // let references = [];
  // let n  = 0;
  source.onmessage = function(event) {
    const eventData = event.data;
    console.log('eventData', typeof eventData);
    try {
      const parseData = JSON.parse(eventData);
      // const {content, tag} = parseData;
      // console.log('content', content);
      func( parseData);
    }
    catch (e) {
      func({content: eventData});
      console.log('JSON.parse(eventData) error===', e);
    }
    // if (parsedData.url) {
    //     references = [...references, parsedData];
    //     console.log('References:', references);
    // }
    //
    // if (parsedData.answer) {
    //     const answer = parsedData.answer;
    //     // 答案输出是流式的，有多次返回
    //     // 遇到终止符时关闭sse连接
    //     if (answer.includes(endSign)){
    //         source.close();
    //     }
    //     if(func) func(answer, references, n);
    //     n ++;
    // }
  };
  source.onerror = function(error) {
    // Handle error
    console.log(error);
    // func('INTERNAL SERVER ERROR' + endSign);
    source.close();
  };
};
//paper问答
export const post_aftergo_chat_message = async (data, func)=>{
  // console.log(rq);
  // data.az = localStorage.getItem('access-token');
  let url = short_answer_url + '?' + dict2params(data);
  var source = new EventSource(url);
  // let references = [];
  // let n  = 0;
  source.onmessage = function(event) {
    const eventData = event.data;
    console.log('eventData', typeof eventData);
    try {
      const parseData = JSON.parse(eventData);
      // const {content, tag} = parseData;
      // console.log('content', content);
      func( parseData);
    }
    catch (e) {
      func({content: eventData});
      console.log('JSON.parse(eventData) error===', e);
    }
    // if (parsedData.url) {
    //     references = [...references, parsedData];
    //     console.log('References:', references);
    // }
    //
    // if (parsedData.answer) {
    //     const answer = parsedData.answer;
    //     // 答案输出是流式的，有多次返回
    //     // 遇到终止符时关闭sse连接
    //     if (answer.includes(endSign)){
    //         source.close();
    //     }
    //     if(func) func(answer, references, n);
    //     n ++;
    // }
  };
  source.onerror = function(error) {
    // Handle error
    console.log(error);
    // func('INTERNAL SERVER ERROR' + endSign);
    source.close();
  };
};

export const post_short_answer = (rq, func)=>{
  // if(isDEV){
  //   func({
  //     "data": {
  //       "account": "hpp_test",
  //       "chat_name": "test",
  //       "chat_no": 1
  //     },
  //     "message": "success",
  //     "status": 1000001
  //   });
  //   return;
  // }
  answer_request({
    type: 'post',
    url: '/lins/short/answer/',
    data: rq,
    crud_name: 'lins问答',
    success: func
  });
};
export const get_biogpt_chat = (func)=>{

  api_request({
    type: 'get',
    url: '/api/v2/biogpt/chat/',
    crud_name: '查看对话列表',
    success: func
  });
};
function getItem(
    label,
    key,
    icon,
    children,
    type,
) {
  return {
    key,
    icon,
    children,
    label,
    type,
    menu: label,
  };
}
export const formatChats = (res)=>{
  let {data} = res;
  let items1 = [];
  let items7 = [];
  let items30 = [];
  let more = [];
  let now = new Date();
  data = data || [];
  data.reverse();
  data.map(item=>{
    let {chat_name, create_time, chat_no} = item;
    create_time *= 1000;
    let diff = now - create_time;
    let ms = 24 * 60 * 60 * 1000;
    if(!chat_name) chat_name = moment(create_time).format('YYYY-MM-DD HH:mm:ss');
    let menuItem = {label: chat_name, key: chat_no, chat_no};
    if(diff <= ms) items1 = [...items1, menuItem];
    else if(diff <= 7 * ms) items7 = [...items7, menuItem];
    else if(diff <= 30 * ms) items30 = [...items30, menuItem];
    else more = [...more, menuItem];
  });
  let menuItems = [];
  if(items1.length > 0) menuItems = [...menuItems, getItem('Today', '1d', null, items1, 'group')];
  if(items7.length > 0) menuItems = [...menuItems, getItem('Previous 7 Days', '7d', null, items7, 'group'),];
  if(items30.length > 0) menuItems = [...menuItems, getItem('Previous 30 Days', '30d', null, items30, 'group'),];
  if(more.length > 0) menuItems = [...menuItems, getItem('More', 'more', null, more, 'group')];
  return menuItems;
};
export const delete_biogpt_chat = (rq, func)=>{
  if(isDEV){
    func({
      "data": {
        "chat_no": 1
      },
      "message": "success",
      "status": 1000001
    });
    return;
  }
  api_request({
    type: 'delete',
    url: '/api/v2/biogpt/chat/',
    data: rq,
    crud_name: '删除对话',
    success: func
  });
};

export const post_biogpt_chat_query = (rq, func)=>{
  // if(isDEV){
  //   // 普通对话请求示例
  //   rq = {
  //     "chat_no": 1,
  //     "message_type": 1,
  //     "msg": "你好",
  //     "model": "GPT-3.5"
  //   };
  //   // 发起分析任务示例
  //   // rq = {
  //   //     "chat_no": 1,
  //   //     "message_type": 2,
  //   //     "msg": "我有一个二分类数据集：{origin.csv}，包含了一些数据和对应的标签，需要先划分数据集，并选择五个合适的分类器做预测，进行acc的计算，最后选择最优的分类器进行预测。",
  //   //     "model": "GPT-3.5",
  //   //     "task_files": [
  //   //         "/mnt/data/biogpt/example/origin.csv"
  //   //     ]
  //   // }
  //   func({
  //     "data": {task_id: 'demo', payload: {message: 'started', stage: 'start'}},
  //     "message": "success",
  //     "status": 1000001
  //   });
  //   return;
  // }
  api_request({
    type: 'post',
    url: '/api/v2/biogpt/chat/query/',
    data: rq,
    crud_name: '普通对话、发起分析',
    success: func
  });
};
export const get_biogpt_chat_messages = (rq, func)=>{
  api_request({
    type: 'get',
    url: '/api/v2/biogpt/chat/messages/',
    data: rq,
    crud_name: '查看聊天记录',
    success: func
  });
};
export const get_biogpt_task = (rq, func)=>{
  // if(isDEV){
  //   // rq = {
  //   //     "chat_no": 1
  //   // }
  //   // 0failed 1start 2improve_prompt 3tool_score 4workflow 5code 6summary 7completed
  //   // let stage = 'failed', task_stage = 0;
  //   let stage = 'completedNew', task_stage = 7;
  //   // let stage = 'start', task_stage = 1;
  //   // let stage = 'improve_prompt', task_stage = 2;
  //   // let stage = 'tool_score', task_stage = 3;
  //   func({
  //     "data": {
  //       "add_time": 1714092872,
  //       "chat_no": 1,
  //       "is_self": 1,
  //       "message_no": 18,
  //       "message_type": 2,
  //       "model": "GPT-3.5",
  //       "payload": require('@/json/api-format/'+stage+''),
  //       "task_files": [
  //         "/mnt/data/biogpt/example/origin.csv"
  //       ],
  //       "task_id": "8573b275-21b2-40d2-b06a-a1263d07eadc",
  //       "task_stage": task_stage,
  //       "update_time": 1714092872
  //     },
  //     "message": "success",
  //     "status": 1000001
  //   });
  //   return;
  // }
  api_request({
    type: 'get',
    url: '/api/v2/biogpt/task/',
    data: rq,
    crud_name: '查看聊天记录',
    success: func
  });
};
export const get_biogpt_task_list = (func)=>{
  if(isDEV){
    func({
      "status": 1000001,
      "message": "success",
      "data": [
        {
          "task_stage": 0,
          "task_id": "a2c28592-ab0d-4406-a411-aba9467ab8f0",
          "cite_task_id": null,
          "task_query": null,
          "update_time": 1714014975,
          "stars": 3,
          "model": "GPT-3.5",
          "public": 0,
          "cite_no": 0,
          "add_time": 1714014975
        },
        {
          "task_stage": 2,
          "task_id": "6a74f22f-5b51-4199-88e2-0bcf2d372bc6",
          "cite_task_id": null,
          "task_query": null,
          "update_time": 1714015422,
          "stars": 0,
          "model": "GPT-3.5",
          "public": 0,
          "cite_no": 0,
          "add_time": 1714015043
        },
        {
          "task_stage": 6,
          "task_id": "2fa36850-7e80-4e98-8902-b00cd01e9d0e",
          "cite_task_id": null,
          "task_query": null,
          "update_time": 1714016373,
          "stars": 0,
          "model": "GPT-3.5",
          "public": 0,
          "cite_no": 0,
          "add_time": 1714016373
        },
        {
          "task_stage": 7,
          "task_id": "2fa36850-7e80-4e98-8902-b00cd01e9d0e",
          "cite_task_id": null,
          "task_query": null,
          "update_time": 1714016373,
          "stars": 0,
          "model": "GPT-3.5",
          "public": 0,
          "cite_no": 0,
          "add_time": 1714016373
        }
      ]
    });
    return;
  }
  api_request({
    type: 'get',
    url: '/api/v2/biogpt/task/list/',
    crud_name: '查看任务列表',
    success: func
  });
};
export const put_biogpt_task = (rq, func)=>{
  if(isDEV){
    func({
      "status": 2000001,
      "message": "success",
      "data": {
        "task_id": "8573b275-21b2-40d2-b06a-a1263d07eadc",
        "public": 1
      }
    });
    return;
  }
  api_request({
    type: 'put',
    data: rq,
    url: '/api/v2/biogpt/task/',
    crud_name: '查看任务列表',
    success: func
  });
};
export const get_biogpt_tools = (rq, func)=>{
  if(isDEV){
    func({
      "data": [
        {
          "abandon": 0,
          "account": "hpp_test",
          "add_time": 1721095164,
          "cite_count": 0,
          "description": "This is a regression tool. Enter two csv files, the training set and the test set. Also enter the column name for the label column. Use the tool to train on the training set and then on the test set Predict and output the prediction result file on the test set. The output result file has the predicted value column \"Predicted\" added compared to the input test set. The algorithm used is SVM Regressor",
          "failed_message": "",
          "mount_point": null,
          "param_input": [
            {
              "description": "Variant Call Format files",
              "example": "/mnt/data/bioinfogpt/users/hpp_test/GJX-lung.pass.vcf",
              "name": "vcf_file",
              "system_example": "/mnt/data/bioinfogpt/tools/examples/5ee968a890b243fea69312b0eaddd2bd/GJX-lung.pass.vcf",
              "type": "file"
            }
          ],
          "param_output": [
            {
              "description": "Maf Format files",
              "example": "/mnt/data/bioinfogpt/users/hpp_test/test.maf",
              "name": "maf_file",
              "system_example": "/mnt/data/bioinfogpt/tools/examples/5ee968a890b243fea69312b0eaddd2bd/test.maf",
              "type": "file"
            }
          ],
          "review_message": "",
          "review_status": 1,
          "script": "\nimport os\nimport docker\n\ndef vcf_to_maf(vcf_file):                       # 工具名， 参数列表\n    if not vcf_file.endswith(\".vcf\"):           # 输入文件检查\n        raise ValueError(\"Invalid file name\")\n    \n    current_path = os.getcwd()\n    output_header = vcf_file.split(\".\")[0]       # 输出文件前缀（可选）\n    client = docker.from_env()\n\n    container_config = {                    \n    'image': 'bc_vcf2maf',                  # 使用的镜像\n    'command': '/bin/bash',                 \n    'tty': True,                            \n    'stdin_open': True,                     \n    'volumes': {                            # 挂载主机目录到容器中\n        current_path: {                     # 输入输出文件所在目录（一般不需要修改）\n            'bind': '/io_data',             # 映射到docker中的目录\n            'mode': 'rw'\n        },\n        '/mnt/data/fastq2vcf': {            # docker中要运行的脚本所在目录\n            'bind': '/data',                # 映射到docker中的目录\n            'mode': 'rw'\n        }\n    },\n    'detach': True\n    }\n    container = client.containers.run(**container_config)\n    \n    \n    # docker中的运行脚本的命令，指定输入文件与输出文件等\n    command = f\"perl /opt/mskcc-vcf2maf/vcf2maf.pl --input-vcf /io_data/{vcf_file} --output-maf /io_data/{output_header}.maf --tumor-id tumor --normal-id normal --ref-fasta /data/reference/hg19/ucsc.hg19.nochr.fasta --ncbi-build GRCh37 --species homo_sapiens --vep-data /data/reference/vep --vep-path /opt/vep/src/ensembl-vep/ --cache-version 97\"\n\n\n    output = container.exec_run(command)     \n    # print(result.exit_code, result.output.decode('utf-8'))\n    container.stop()\n    container.remove()\n    if \"Error\" in output or \"error\" in output:\n        raise Exception(output)\n\n    output_file = output_header + \".maf\"                     # 后处理：文件存在检查\n    # output_file1, output_file2 = \"xxx.maf\", \"xxxx.maf\"    \n    for f in [output_file]:                                 # 后处理：文件存在检查\n    # for f in [output_file1, output_file2]\n        if not os.path.exists(f):                           \n            raise FileNotFoundError(f\"{f} is not found\")\n    return output_file                                      # 函数的返回值（输出文件的文件名）\n\nif __name__ == \"__main__\":\n    res = vcf_to_maf(\"GJX-lung.pass.vcf\")\n    print(res)\n",
          "stage": 2,
          "task_id": "adcced84-d5b7-40cd-bb50-69fb24c4dc29",
          "task_query": "我有一个突变的vcf文件{GJX-lung.pass.vcf}，利用vcf2maf5进行变异注释生成maf文件",
          "tool_id": "5ee968a890b243fea69312b0eaddd2bd",
          "tool_name": "vcf2maf5",
          "tool_release": 0,
          "update_time": 1721095164,
          "user_image_path": "/mnt/data/bioinfogpt/tools/images/bioinfogpt/bc_vcf2maf.tar",
          "user_tar_path": null
        },
        {
          "abandon": 0,
          "account": "hpp_test",
          "add_time": 1720172180,
          "cite_count": 0,
          "description": "Variant Call Format files\n",
          "failed_message": null,
          "mount_point": "/opt",
          "param_input": [
            {
              "description": "Variant Call Format files\n",
              "example": "/mnt/data/bioinfogpt/users/hpp_test/GJX-lung.pass.vcf",
              "name": "input_vcf",
              "param_name": "/io_data/GJX-lung.pass.vcf",
              "system_example": "/mnt/data/bioinfogpt/tools/examples/a7d8ae834c1945bf849e78ff210db831/GJX-lung.pass.vcf",
              "type": "file"
            }
          ],
          "param_output": [
            {
              "description": "Mutation annotation information (MAF) format file\n",
              "example": "/mnt/data/bioinfogpt/users/hpp_test/test.maf",
              "get_from_input": true,
              "get_from_output": true,
              "input_param": "input_vcf",
              "name": "output_maf",
              "param_name": "/io_data/GJX-lung.pass.maf",
              "system_example": "/mnt/data/bioinfogpt/tools/examples/a7d8ae834c1945bf849e78ff210db831/test.maf",
              "type": "file"
            }
          ],
          "review_message": "",
          "review_status": 1,
          "script": "def vcf_to_maf(input_vcf):\n    \n    if not input_vcf.endswith(\".vcf\"):\n        raise ValueError(\"Invalid file name\")\n        \n\n    current_path = os.getcwd()\n    output_header0 = \".\".join(input_vcf.split(\".\")[0:-1])\n\n    client = docker.from_env()\n\n    container_config = {\n    'image': \"vcf_to_maf:17201721054306104\",\n    'command': '/bin/bash',\n    'tty': True,\n    'stdin_open': True,\n    'volumes': {\n        current_path: {\n            'bind': '/io_data',\n            'mode': 'rw'\n        }\n    },\n    'detach': True\n    }\n    container = client.containers.run(**container_config)\n\n    command = f\"perl /opt/mskcc-vcf2maf/vcf2maf.pl --input-vcf /io_data/{input_vcf} --output-maf /io_data/{output_header0}.maf --tumor-id tumor --normal-id normal --ref-fasta /data/reference/hg19/ucsc.hg19.nochr.fasta --ncbi-build GRCh37 --species homo_sapiens --vep-data /data/reference/vep --vep-path /opt/vep/src/ensembl-vep/ --cache-version 97\"\n\n    output = container.exec_run(command)\n    # print(result.exit_code, result.output.decode('utf-8'))\n    container.stop()\n    container.remove()\n    if \"Error\" in output or \"error\" in output:\n        raise Exception(output)\n\n    output_maf = output_header0+\".maf\"\n    for f in [output_maf]:\n        if not os.path.exists(f):\n            raise FileNotFoundError(f\"{f} is not found\")\n    return output_maf",
          "stage": 1,
          "task_id": null,
          "task_query": null,
          "tool_id": "a7d8ae834c1945bf849e78ff210db831",
          "tool_name": "vcf_to_maf",
          "tool_release": 0,
          "update_time": 1720172180,
          "user_image_path": "/mnt/data/bioinfogpt/tools/images/bioinfogpt/bc_vcf2maf.tar",
          "user_tar_path": null
        },
        {
          "abandon": 0,
          "account": "hpp_test",
          "add_time": 1720171509,
          "cite_count": 0,
          "description": "A tool used to convert a VCF file into a MAF file\n",
          "failed_message": "",
          "mount_point": "/opt",
          "param_input": [
            {
              "description": "Variant Call Format files\n",
              "example": "/mnt/data/bioinfogpt/users/hpp_test/GJX-lung.pass.vcf",
              "name": "input_vcf",
              "param_name": "/io_data/GJX-lung.pass.vcf",
              "system_example": "/mnt/data/bioinfogpt/tools/examples/8301c754110a44c0a9d3bdbe65ef8c55/GJX-lung.pass.vcf",
              "type": "file"
            }
          ],
          "param_output": [
            {
              "description": "Mutation annotation information (MAF) format file\n",
              "example": "/mnt/data/bioinfogpt/users/hpp_test/test.maf",
              "get_from_input": true,
              "get_from_output": true,
              "input_param": "input_vcf",
              "name": "output_maf",
              "param_name": "/io_data/GJX-lung.pass.maf",
              "system_example": "/mnt/data/bioinfogpt/tools/examples/8301c754110a44c0a9d3bdbe65ef8c55/test.maf",
              "type": "file"
            }
          ],
          "review_message": "",
          "review_status": 1,
          "script": "def vcf_to_maf(input_vcf):\n    \n    if not input_vcf.endswith(\".vcf\"):\n        raise ValueError(\"Invalid file name\")\n        \n\n    current_path = os.getcwd()\n    output_header0 = \".\".join(input_vcf.split(\".\")[0:-1])\n\n    client = docker.from_env()\n\n    container_config = {\n    'image': \"vcf_to_maf:17201714964205961\",\n    'command': '/bin/bash',\n    'tty': True,\n    'stdin_open': True,\n    'volumes': {\n        current_path: {\n            'bind': '/io_data',\n            'mode': 'rw'\n        }\n    },\n    'detach': True\n    }\n    container = client.containers.run(**container_config)\n\n    command = f\"perl /opt/mskcc-vcf2maf/vcf2maf.pl --input-vcf /io_data/{input_vcf} --output-maf /io_data/{output_header0}.maf --tumor-id tumor --normal-id normal --ref-fasta /data/reference/hg19/ucsc.hg19.nochr.fasta --ncbi-build GRCh37 --species homo_sapiens --vep-data /data/reference/vep --vep-path /opt/vep/src/ensembl-vep/ --cache-version 97\"\n\n    output = container.exec_run(command)\n    # print(result.exit_code, result.output.decode('utf-8'))\n    container.stop()\n    container.remove()\n    if \"Error\" in output or \"error\" in output:\n        raise Exception(output)\n\n    output_maf = output_header0+\".maf\"\n    for f in [output_maf]:\n        if not os.path.exists(f):\n            raise FileNotFoundError(f\"{f} is not found\")\n    return output_maf",
          "stage": 2,
          "task_id": null,
          "task_query": null,
          "tool_id": "8301c754110a44c0a9d3bdbe65ef8c55",
          "tool_name": "vcf_to_maf",
          "tool_release": 0,
          "update_time": 1720171509,
          "user_image_path": "/mnt/data/bioinfogpt/tools/images/bioinfogpt/bc_vcf2maf.tar",
          "user_tar_path": null
        },
        {
          "abandon": 0,
          "account": "hpp_test",
          "add_time": 1720149657,
          "cite_count": 0,
          "description": "描述",
          "failed_message": null,
          "mount_point": null,
          "param_input": [
            {
              "description": "Variant Call Format files",
              "example": "/mnt/data/bioinfogpt/users/hpp_test/GJX-lung.pass.vcf",
              "name": "vcf_file",
              "system_example": "/mnt/data/bioinfogpt/tools/examples/6bafd9f5f76e4e02b5118f3a6c55632f/GJX-lung.pass.vcf",
              "type": "file"
            }
          ],
          "param_output": [
            {
              "description": "Maf Format files",
              "example": "/mnt/data/bioinfogpt/users/hpp_test/test.maf",
              "name": "maf_file",
              "system_example": "/mnt/data/bioinfogpt/tools/examples/6bafd9f5f76e4e02b5118f3a6c55632f/test.maf",
              "type": "file"
            }
          ],
          "review_message": "",
          "review_status": 3,
          "script": "\nimport os\nimport docker\n\ndef vcf_to_maf(vcf_file):                       # 工具名， 参数列表\n    if not vcf_file.endswith(\".vcf\"):           # 输入文件检查\n        raise ValueError(\"Invalid file name\")\n    \n    current_path = os.getcwd()\n    output_header = vcf_file.split(\".\")[0]       # 输出文件前缀（可选）\n    client = docker.from_env()\n\n    container_config = {                    \n    'image': 'bc_vcf2maf',                  # 使用的镜像\n    'command': '/bin/bash',                 \n    'tty': True,                            \n    'stdin_open': True,                     \n    'volumes': {                            # 挂载主机目录到容器中\n        current_path: {                     # 输入输出文件所在目录（一般不需要修改）\n            'bind': '/io_data',             # 映射到docker中的目录\n            'mode': 'rw'\n        },\n        '/mnt/data/fastq2vcf': {            # docker中要运行的脚本所在目录\n            'bind': '/data',                # 映射到docker中的目录\n            'mode': 'rw'\n        }\n    },\n    'detach': True\n    }\n    container = client.containers.run(**container_config)\n    \n    \n    # docker中的运行脚本的命令，指定输入文件与输出文件等\n    command = f\"perl /opt/mskcc-vcf2maf/vcf2maf.pl --input-vcf /io_data/{vcf_file} --output-maf /io_data/{output_header}.maf --tumor-id tumor --normal-id normal --ref-fasta /data/reference/hg19/ucsc.hg19.nochr.fasta --ncbi-build GRCh37 --species homo_sapiens --vep-data /data/reference/vep --vep-path /opt/vep/src/ensembl-vep/ --cache-version 97\"\n\n\n    output = container.exec_run(command)     \n    # print(result.exit_code, result.output.decode('utf-8'))\n    container.stop()\n    container.remove()\n    if \"Error\" in output or \"error\" in output:\n        raise Exception(output)\n\n    output_file = output_header + \".maf\"                     # 后处理：文件存在检查\n    # output_file1, output_file2 = \"xxx.maf\", \"xxxx.maf\"    \n    for f in [output_file]:                                 # 后处理：文件存在检查\n    # for f in [output_file1, output_file2]\n        if not os.path.exists(f):                           \n            raise FileNotFoundError(f\"{f} is not found\")\n    return output_file                                      # 函数的返回值（输出文件的文件名）\n\nif __name__ == \"__main__\":\n    res = vcf_to_maf(\"GJX-lung.pass.vcf\")\n    print(res)\n",
          "stage": 4,
          "task_id": null,
          "task_query": null,
          "tool_id": "6bafd9f5f76e4e02b5118f3a6c55632f",
          "tool_name": "vcf2maf",
          "tool_release": 1,
          "update_time": 1720149657,
          "user_image_path": "/mnt/data/bioinfogpt/tools/images/bioinfogpt/bc_vcf2maf.tar",
          "user_tar_path": null
        },
        {
          "abandon": 0,
          "account": "hpp_test",
          "add_time": 1720148936,
          "cite_count": 0,
          "description": "描述",
          "failed_message": null,
          "mount_point": null,
          "param_input": [
            {
              "description": "Variant Call Format files",
              "example": "/mnt/data/bioinfogpt/users/hpp_test/GJX-lung.pass.vcf",
              "name": "vcf_file",
              "system_example": "/mnt/data/bioinfogpt/tools/examples/ad5e7f6f805b49dfbf9765a2cb0d859c/GJX-lung.pass.vcf",
              "type": "file"
            }
          ],
          "param_output": [
            {
              "description": "Maf Format files",
              "example": "/mnt/data/bioinfogpt/users/hpp_test/test.maf",
              "name": "maf_file",
              "system_example": "/mnt/data/bioinfogpt/tools/examples/ad5e7f6f805b49dfbf9765a2cb0d859c/test.maf",
              "type": "file"
            }
          ],
          "review_message": "",
          "review_status": 3,
          "script": "\nimport os\nimport docker\n\ndef vcf_to_maf(vcf_file):                       # 工具名， 参数列表\n    if not vcf_file.endswith(\".vcf\"):           # 输入文件检查\n        raise ValueError(\"Invalid file name\")\n    \n    current_path = os.getcwd()\n    output_header = vcf_file.split(\".\")[0]       # 输出文件前缀（可选）\n    client = docker.from_env()\n\n    container_config = {                    \n    'image': 'bc_vcf2maf',                  # 使用的镜像\n    'command': '/bin/bash',                 \n    'tty': True,                            \n    'stdin_open': True,                     \n    'volumes': {                            # 挂载主机目录到容器中\n        current_path: {                     # 输入输出文件所在目录（一般不需要修改）\n            'bind': '/io_data',             # 映射到docker中的目录\n            'mode': 'rw'\n        },\n        '/mnt/data/fastq2vcf': {            # docker中要运行的脚本所在目录\n            'bind': '/data',                # 映射到docker中的目录\n            'mode': 'rw'\n        }\n    },\n    'detach': True\n    }\n    container = client.containers.run(**container_config)\n    \n    \n    # docker中的运行脚本的命令，指定输入文件与输出文件等\n    command = f\"perl /opt/mskcc-vcf2maf/vcf2maf.pl --input-vcf /io_data/{vcf_file} --output-maf /io_data/{output_header}.maf --tumor-id tumor --normal-id normal --ref-fasta /data/reference/hg19/ucsc.hg19.nochr.fasta --ncbi-build GRCh37 --species homo_sapiens --vep-data /data/reference/vep --vep-path /opt/vep/src/ensembl-vep/ --cache-version 97\"\n\n\n    output = container.exec_run(command)     \n    # print(result.exit_code, result.output.decode('utf-8'))\n    container.stop()\n    container.remove()\n    if \"Error\" in output or \"error\" in output:\n        raise Exception(output)\n\n    output_file = output_header + \".maf\"                     # 后处理：文件存在检查\n    # output_file1, output_file2 = \"xxx.maf\", \"xxxx.maf\"    \n    for f in [output_file]:                                 # 后处理：文件存在检查\n    # for f in [output_file1, output_file2]\n        if not os.path.exists(f):                           \n            raise FileNotFoundError(f\"{f} is not found\")\n    return output_file                                      # 函数的返回值（输出文件的文件名）\n\nif __name__ == \"__main__\":\n    res = vcf_to_maf(\"GJX-lung.pass.vcf\")\n    print(res)\n",
          "stage": 4,
          "task_id": null,
          "task_query": null,
          "tool_id": "ad5e7f6f805b49dfbf9765a2cb0d859c",
          "tool_name": "vcf2maf",
          "tool_release": 1,
          "update_time": 1720148936,
          "user_image_path": "/mnt/data/bioinfogpt/tools/images/bioinfogpt/bc_vcf2maf.tar",
          "user_tar_path": null
        },
        {
          "abandon": 0,
          "account": "hpp_test",
          "add_time": 1720148430,
          "cite_count": 0,
          "description": "描述",
          "failed_message": null,
          "mount_point": null,
          "param_input": [
            {
              "description": "Variant Call Format files",
              "example": "/mnt/data/bioinfogpt/users/hpp_test/GJX-lung.pass.vcf",
              "name": "vcf_file",
              "system_example": "/mnt/data/bioinfogpt/tools/examples/39831f320e8845548f384c0a918f2ddb/GJX-lung.pass.vcf",
              "type": "file"
            }
          ],
          "param_output": [
            {
              "description": "Maf Format files",
              "example": "/mnt/data/bioinfogpt/users/hpp_test/test.maf",
              "name": "maf_file",
              "system_example": "/mnt/data/bioinfogpt/tools/examples/39831f320e8845548f384c0a918f2ddb/test.maf",
              "type": "file"
            }
          ],
          "review_message": "",
          "review_status": 1,
          "script": "\nimport os\nimport docker\n\ndef vcf_to_maf(vcf_file):                       # 工具名， 参数列表\n    if not vcf_file.endswith(\".vcf\"):           # 输入文件检查\n        raise ValueError(\"Invalid file name\")\n    \n    current_path = os.getcwd()\n    output_header = vcf_file.split(\".\")[0]       # 输出文件前缀（可选）\n    client = docker.from_env()\n\n    container_config = {                    \n    'image': 'bc_vcf2maf',                  # 使用的镜像\n    'command': '/bin/bash',                 \n    'tty': True,                            \n    'stdin_open': True,                     \n    'volumes': {                            # 挂载主机目录到容器中\n        current_path: {                     # 输入输出文件所在目录（一般不需要修改）\n            'bind': '/io_data',             # 映射到docker中的目录\n            'mode': 'rw'\n        },\n        '/mnt/data/fastq2vcf': {            # docker中要运行的脚本所在目录\n            'bind': '/data',                # 映射到docker中的目录\n            'mode': 'rw'\n        }\n    },\n    'detach': True\n    }\n    container = client.containers.run(**container_config)\n    \n    \n    # docker中的运行脚本的命令，指定输入文件与输出文件等\n    command = f\"perl /opt/mskcc-vcf2maf/vcf2maf.pl --input-vcf /io_data/{vcf_file} --output-maf /io_data/{output_header}.maf --tumor-id tumor --normal-id normal --ref-fasta /data/reference/hg19/ucsc.hg19.nochr.fasta --ncbi-build GRCh37 --species homo_sapiens --vep-data /data/reference/vep --vep-path /opt/vep/src/ensembl-vep/ --cache-version 97\"\n\n\n    output = container.exec_run(command)     \n    # print(result.exit_code, result.output.decode('utf-8'))\n    container.stop()\n    container.remove()\n    if \"Error\" in output or \"error\" in output:\n        raise Exception(output)\n\n    output_file = output_header + \".maf\"                     # 后处理：文件存在检查\n    # output_file1, output_file2 = \"xxx.maf\", \"xxxx.maf\"    \n    for f in [output_file]:                                 # 后处理：文件存在检查\n    # for f in [output_file1, output_file2]\n        if not os.path.exists(f):                           \n            raise FileNotFoundError(f\"{f} is not found\")\n    return output_file                                      # 函数的返回值（输出文件的文件名）\n\nif __name__ == \"__main__\":\n    res = vcf_to_maf(\"GJX-lung.pass.vcf\")\n    print(res)\n",
          "stage": 1,
          "task_id": null,
          "task_query": null,
          "tool_id": "39831f320e8845548f384c0a918f2ddb",
          "tool_name": "vcf2maf",
          "tool_release": 0,
          "update_time": 1720148430,
          "user_image_path": "/mnt/data/bioinfogpt/tools/images/bioinfogpt/bc_vcf2maf.tar",
          "user_tar_path": null
        },
        {
          command: "perl /opt/mskcc-vcf2maf/vcf2maf.pl --input-vcf /io_data/GJX-lung.pass.vcf --output-maf /io_data/GJX-lung.pass.maf --tumor-id tumor --normal-id normal --ref-fasta /data/reference/hg19/ucsc.hg19.nochr.fasta --ncbi-build GRCh37 --species homo_sapiens --vep-data /data/reference/vep --vep-path /opt/vep/src/ensembl-vep/ --cache-version 97",
          "abandon": 0,
          "account": "hpp_test",
          "add_time": 1720074781,
          "cite_count": 0,
          "description": "test2",
          "failed_message": "Use run tool get Failed: 422",
          "mount_point": null,
          "param_input": [
            {
              "description": "test",
              "example": "/mnt/data/bioinfogpt/users/hpp_test/GJX-lung.pass.vcf",
              "name": "input_vcf",
              "param_name": "/io_data/GJX-lung.pass.vcf",
              "system_example": "/mnt/data/bioinfogpt/tools/examples/042717e6755b4c3cb81e5ac2447b6bb8/GJX-lung.pass.vcf",
              "type": "file"
            }
          ],
          "param_output": [
            {
              "description": "test",
              "example": "/mnt/data/bioinfogpt/users/hpp_test/test.maf",
              "get_from_input": true,
              "get_from_output": true,
              "input_param": "input_vcf",
              "name": "output_maf",
              "param_name": "/io_data/GJX-lung.pass.maf",
              "system_example": "/mnt/data/bioinfogpt/tools/examples/042717e6755b4c3cb81e5ac2447b6bb8/test.maf",
              "type": "file"
            }
          ],
          "review_message": null,
          "review_status": 1,
          "script": "\nimport os\nimport docker\n\ndef vcf_to_maf(vcf_file):                       # 工具名， 参数列表\n    if not vcf_file.endswith(\".vcf\"):           # 输入文件检查\n        raise ValueError(\"Invalid file name\")\n\n    current_path = os.getcwd()\n    output_header = vcf_file.split(\".\")[0]       # 输出文件前缀（可选）\n    client = docker.from_env()\n\n    container_config = {                    \n    'image': 'bc_vcf2maf',                  # 使用的镜像\n    'command': '/bin/bash',                 \n    'tty': True,                            \n    'stdin_open': True,                     \n    'volumes': {                            # 挂载主机目录到容器中\n        current_path: {                     # 输入输出文件所在目录（一般不需要修改）\n            'bind': '/io_data',             # 映射到docker中的目录\n            'mode': 'rw'\n        },\n        '/mnt/data/fastq2vcf': {            # docker中要运行的脚本所在目录\n            'bind': '/data',                # 映射到docker中的目录\n            'mode': 'rw'\n        }\n    },\n    'detach': True\n    }\n    container = client.containers.run(**container_config)\n\n\n    # docker中的运行脚本的命令，指定输入文件与输出文件等\n    command = f\"perl /opt/mskcc-vcf2maf/vcf2maf.pl --input-vcf /io_data/{vcf_file} --output-maf /io_data/{output_header}.maf --tumor-id tumor --normal-id normal --ref-fasta /data/reference/hg19/ucsc.hg19.nochr.fasta --ncbi-build GRCh37 --species homo_sapiens --vep-data /data/reference/vep --vep-path /opt/vep/src/ensembl-vep/ --cache-version 97\"\n\n\n    output = container.exec_run(command)     \n    # print(result.exit_code, result.output.decode('utf-8'))\n    container.stop()\n    container.remove()\n    if \"Error\" in output or \"error\" in output:\n        raise Exception(output)\n\n    output_file = output_header + \".maf\"                     # 后处理：文件存在检查\n    # output_file1, output_file2 = \"xxx.maf\", \"xxxx.maf\"    \n    for f in [output_file]:                                 # 后处理：文件存在检查\n    # for f in [output_file1, output_file2]\n        if not os.path.exists(f):                           \n            raise FileNotFoundError(f\"{f} is not found\")\n    return output_file                                      # 函数的返回值（输出文件的文件名）\n\nif __name__ == \"__main__\":\n    res = vcf_to_maf(\"GJX-lung.pass.vcf\")\n    print(res)\n",
          "stage": -1,
          "task_id": null,
          "task_query": null,
          "tool_id": "d67f681efa5448319275f57ba9ef9aec",
          "tool_name": "vcf2maf6",
          "fun_name": "vcf2maf6",
          "tool_release": 0,
          "update_time": 1720769072,
          "user_image_path": "/mnt/data/bioinfogpt/tools/images/bioinfogpt/bc_vcf2maf.tar",
          "user_tar_path": null
        },
        {
          "abandon": 0,
          "account": "hpp_test",
          "add_time": 1720074407,
          "cite_count": 0,
          "description": "描述",
          "failed_message": "",
          "mount_point": null,
          "param_input": [
            {
              "description": "Variant Call Format files",
              "example": "/mnt/data/bioinfogpt/users/hpp_test/GJX-lung.pass.vcf",
              "name": "vcf_file",
              "system_example": "/mnt/data/bioinfogpt/tools/examples/72c8ca3abb4d4cf98d49d76841cb8739/GJX-lung.pass.vcf",
              "type": "file"
            }
          ],
          "param_output": [
            {
              "description": "Maf Format files",
              "example": "/mnt/data/bioinfogpt/users/hpp_test/test.maf",
              "name": "maf_file",
              "system_example": "/mnt/data/bioinfogpt/tools/examples/72c8ca3abb4d4cf98d49d76841cb8739/test.maf",
              "type": "file"
            }
          ],
          "review_message": "",
          "review_status": 1,
          "script": "\nimport os\nimport docker\n\ndef vcf_to_maf(vcf_file):                       # 工具名， 参数列表\n    if not vcf_file.endswith(\".vcf\"):           # 输入文件检查\n        raise ValueError(\"Invalid file name\")\n    \n    current_path = os.getcwd()\n    output_header = vcf_file.split(\".\")[0]       # 输出文件前缀（可选）\n    client = docker.from_env()\n\n    container_config = {                    \n    'image': 'bc_vcf2maf',                  # 使用的镜像\n    'command': '/bin/bash',                 \n    'tty': True,                            \n    'stdin_open': True,                     \n    'volumes': {                            # 挂载主机目录到容器中\n        current_path: {                     # 输入输出文件所在目录（一般不需要修改）\n            'bind': '/io_data',             # 映射到docker中的目录\n            'mode': 'rw'\n        },\n        '/mnt/data/fastq2vcf': {            # docker中要运行的脚本所在目录\n            'bind': '/data',                # 映射到docker中的目录\n            'mode': 'rw'\n        }\n    },\n    'detach': True\n    }\n    container = client.containers.run(**container_config)\n    \n    \n    # docker中的运行脚本的命令，指定输入文件与输出文件等\n    command = f\"perl /opt/mskcc-vcf2maf/vcf2maf.pl --input-vcf /io_data/{vcf_file} --output-maf /io_data/{output_header}.maf --tumor-id tumor --normal-id normal --ref-fasta /data/reference/hg19/ucsc.hg19.nochr.fasta --ncbi-build GRCh37 --species homo_sapiens --vep-data /data/reference/vep --vep-path /opt/vep/src/ensembl-vep/ --cache-version 97\"\n\n\n    output = container.exec_run(command)     \n    # print(result.exit_code, result.output.decode('utf-8'))\n    container.stop()\n    container.remove()\n    if \"Error\" in output or \"error\" in output:\n        raise Exception(output)\n\n    output_file = output_header + \".maf\"                     # 后处理：文件存在检查\n    # output_file1, output_file2 = \"xxx.maf\", \"xxxx.maf\"    \n    for f in [output_file]:                                 # 后处理：文件存在检查\n    # for f in [output_file1, output_file2]\n        if not os.path.exists(f):                           \n            raise FileNotFoundError(f\"{f} is not found\")\n    return output_file                                      # 函数的返回值（输出文件的文件名）\n\nif __name__ == \"__main__\":\n    res = vcf_to_maf(\"GJX-lung.pass.vcf\")\n    print(res)\n",
          "stage": 2,
          "task_id": null,
          "task_query": null,
          "tool_id": "72c8ca3abb4d4cf98d49d76841cb8739",
          "tool_name": "vcf2maf",
          "tool_release": 0,
          "update_time": 1720074407,
          "user_image_path": "/mnt/data/bioinfogpt/tools/images/bioinfogpt/bc_vcf2maf.tar",
          "user_tar_path": null
        },
        {
          "abandon": 0,
          "account": "hpp_test",
          "add_time": 1719991541,
          "cite_count": 0,
          "description": "test2",
          "failed_message": "Use run tool get Failed: 500",
          "mount_point": null,
          "param_input": [
            {
              "description": "Variant Call Format files",
              "example": "/mnt/data/bioinfogpt/users/hpp_test/GJX-lung.pass.vcf",
              "name": "vcf_file",
              "system_example": "/mnt/data/bioinfogpt/tools/examples/d98102051cf741b2881a450e3faf0675/GJX-lung.pass.vcf",
              "type": "file"
            }
          ],
          "param_output": [
            {
              "description": "Maf Format files",
              "example": "/mnt/data/bioinfogpt/users/hpp_test/test.maf",
              "name": "maf_file",
              "system_example": "/mnt/data/bioinfogpt/tools/examples/d98102051cf741b2881a450e3faf0675/test.maf",
              "type": "file"
            }
          ],
          "review_message": null,
          "review_status": 1,
          "script": "\nimport os\nimport docker\n\ndef vcf_to_maf(vcf_file):                       # 工具名， 参数列表\n    if not vcf_file.endswith(\".vcf\"):           # 输入文件检查\n        raise ValueError(\"Invalid file name\")\n\n    current_path = os.getcwd()\n    output_header = vcf_file.split(\".\")[0]       # 输出文件前缀（可选）\n    client = docker.from_env()\n\n    container_config = {                    \n    'image': 'bc_vcf2maf',                  # 使用的镜像\n    'command': '/bin/bash',                 \n    'tty': True,                            \n    'stdin_open': True,                     \n    'volumes': {                            # 挂载主机目录到容器中\n        current_path: {                     # 输入输出文件所在目录（一般不需要修改）\n            'bind': '/io_data',             # 映射到docker中的目录\n            'mode': 'rw'\n        },\n        '/mnt/data/fastq2vcf': {            # docker中要运行的脚本所在目录\n            'bind': '/data',                # 映射到docker中的目录\n            'mode': 'rw'\n        }\n    },\n    'detach': True\n    }\n    container = client.containers.run(**container_config)\n\n\n    # docker中的运行脚本的命令，指定输入文件与输出文件等\n    command = f\"perl /opt/mskcc-vcf2maf/vcf2maf.pl --input-vcf /io_data/{vcf_file} --output-maf /io_data/{output_header}.maf --tumor-id tumor --normal-id normal --ref-fasta /data/reference/hg19/ucsc.hg19.nochr.fasta --ncbi-build GRCh37 --species homo_sapiens --vep-data /data/reference/vep --vep-path /opt/vep/src/ensembl-vep/ --cache-version 97\"\n\n\n    output = container.exec_run(command)     \n    # print(result.exit_code, result.output.decode('utf-8'))\n    container.stop()\n    container.remove()\n    if \"Error\" in output or \"error\" in output:\n        raise Exception(output)\n\n    output_file = output_header + \".maf\"                     # 后处理：文件存在检查\n    # output_file1, output_file2 = \"xxx.maf\", \"xxxx.maf\"    \n    for f in [output_file]:                                 # 后处理：文件存在检查\n    # for f in [output_file1, output_file2]\n        if not os.path.exists(f):                           \n            raise FileNotFoundError(f\"{f} is not found\")\n    return output_file                                      # 函数的返回值（输出文件的文件名）\n\nif __name__ == \"__main__\":\n    res = vcf_to_maf(\"GJX-lung.pass.vcf\")\n    print(res)\n",
          "stage": 2,
          "task_id": null,
          "task_query": null,
          "tool_id": "d98102051cf741b2881a450e3faf0675",
          "tool_name": "vcf2maf2",
          "tool_release": 0,
          "update_time": 1720509885,
          "user_image_path": "/mnt/data/bioinfogpt/tools/images/bioinfogpt/bc_vcf2maf.tar",
          "user_tar_path": null
        }
      ],
      "message": "success",
      "status": 1000001
    });
    return;
  }
  api_request({
    type: 'get',
    url: '/api/v2/biogpt/tools/mine/',
    data: rq,
    crud_name: '查看我的工具',
    success: func
  });
};
export const get_biogpt_tools_admin = (rq, func)=>{
  if(isDEV){
    func({
      "data": [
        {
          "abandon": 0,
          "account": "hpp_test",
          "add_time": 1721095164,
          "cite_count": 0,
          "description": "描述",
          "failed_message": "",
          "mount_point": null,
          "param_input": [
            {
              "description": "Variant Call Format files",
              "example": "/mnt/data/bioinfogpt/users/hpp_test/GJX-lung.pass.vcf",
              "name": "vcf_file",
              "system_example": "/mnt/data/bioinfogpt/tools/examples/5ee968a890b243fea69312b0eaddd2bd/GJX-lung.pass.vcf",
              "type": "file"
            }
          ],
          "param_output": [
            {
              "description": "Maf Format files",
              "example": "/mnt/data/bioinfogpt/users/hpp_test/test.maf",
              "name": "maf_file",
              "system_example": "/mnt/data/bioinfogpt/tools/examples/5ee968a890b243fea69312b0eaddd2bd/test.maf",
              "type": "file"
            }
          ],
          "review_message": "",
          "review_status": 1,
          "script": "\nimport os\nimport docker\n\ndef vcf_to_maf(vcf_file):                       # 工具名， 参数列表\n    if not vcf_file.endswith(\".vcf\"):           # 输入文件检查\n        raise ValueError(\"Invalid file name\")\n    \n    current_path = os.getcwd()\n    output_header = vcf_file.split(\".\")[0]       # 输出文件前缀（可选）\n    client = docker.from_env()\n\n    container_config = {                    \n    'image': 'bc_vcf2maf',                  # 使用的镜像\n    'command': '/bin/bash',                 \n    'tty': True,                            \n    'stdin_open': True,                     \n    'volumes': {                            # 挂载主机目录到容器中\n        current_path: {                     # 输入输出文件所在目录（一般不需要修改）\n            'bind': '/io_data',             # 映射到docker中的目录\n            'mode': 'rw'\n        },\n        '/mnt/data/fastq2vcf': {            # docker中要运行的脚本所在目录\n            'bind': '/data',                # 映射到docker中的目录\n            'mode': 'rw'\n        }\n    },\n    'detach': True\n    }\n    container = client.containers.run(**container_config)\n    \n    \n    # docker中的运行脚本的命令，指定输入文件与输出文件等\n    command = f\"perl /opt/mskcc-vcf2maf/vcf2maf.pl --input-vcf /io_data/{vcf_file} --output-maf /io_data/{output_header}.maf --tumor-id tumor --normal-id normal --ref-fasta /data/reference/hg19/ucsc.hg19.nochr.fasta --ncbi-build GRCh37 --species homo_sapiens --vep-data /data/reference/vep --vep-path /opt/vep/src/ensembl-vep/ --cache-version 97\"\n\n\n    output = container.exec_run(command)     \n    # print(result.exit_code, result.output.decode('utf-8'))\n    container.stop()\n    container.remove()\n    if \"Error\" in output or \"error\" in output:\n        raise Exception(output)\n\n    output_file = output_header + \".maf\"                     # 后处理：文件存在检查\n    # output_file1, output_file2 = \"xxx.maf\", \"xxxx.maf\"    \n    for f in [output_file]:                                 # 后处理：文件存在检查\n    # for f in [output_file1, output_file2]\n        if not os.path.exists(f):                           \n            raise FileNotFoundError(f\"{f} is not found\")\n    return output_file                                      # 函数的返回值（输出文件的文件名）\n\nif __name__ == \"__main__\":\n    res = vcf_to_maf(\"GJX-lung.pass.vcf\")\n    print(res)\n",
          "stage": 2,
          "task_id": "adcced84-d5b7-40cd-bb50-69fb24c4dc29",
          "task_query": "我有一个突变的vcf文件{GJX-lung.pass.vcf}，利用vcf2maf5进行变异注释生成maf文件",
          "tool_id": "5ee968a890b243fea69312b0eaddd2bd",
          "tool_name": "vcf2maf5",
          "tool_release": 0,
          "update_time": 1721095164,
          "user_image_path": "/mnt/data/bioinfogpt/tools/images/bioinfogpt/bc_vcf2maf.tar",
          "user_tar_path": null
        },
        {
          "abandon": 0,
          "account": "hpp_test",
          "add_time": 1720172180,
          "cite_count": 0,
          "description": "Variant Call Format files\n",
          "failed_message": null,
          "mount_point": "/opt",
          "param_input": [
            {
              "description": "Variant Call Format files\n",
              "example": "/mnt/data/bioinfogpt/users/hpp_test/GJX-lung.pass.vcf",
              "name": "input_vcf",
              "param_name": "/io_data/GJX-lung.pass.vcf",
              "system_example": "/mnt/data/bioinfogpt/tools/examples/a7d8ae834c1945bf849e78ff210db831/GJX-lung.pass.vcf",
              "type": "file"
            }
          ],
          "param_output": [
            {
              "description": "Mutation annotation information (MAF) format file\n",
              "example": "/mnt/data/bioinfogpt/users/hpp_test/test.maf",
              "get_from_input": true,
              "get_from_output": true,
              "input_param": "input_vcf",
              "name": "output_maf",
              "param_name": "/io_data/GJX-lung.pass.maf",
              "system_example": "/mnt/data/bioinfogpt/tools/examples/a7d8ae834c1945bf849e78ff210db831/test.maf",
              "type": "file"
            }
          ],
          "review_message": "",
          "review_status": 1,
          "script": "def vcf_to_maf(input_vcf):\n    \n    if not input_vcf.endswith(\".vcf\"):\n        raise ValueError(\"Invalid file name\")\n        \n\n    current_path = os.getcwd()\n    output_header0 = \".\".join(input_vcf.split(\".\")[0:-1])\n\n    client = docker.from_env()\n\n    container_config = {\n    'image': \"vcf_to_maf:17201721054306104\",\n    'command': '/bin/bash',\n    'tty': True,\n    'stdin_open': True,\n    'volumes': {\n        current_path: {\n            'bind': '/io_data',\n            'mode': 'rw'\n        }\n    },\n    'detach': True\n    }\n    container = client.containers.run(**container_config)\n\n    command = f\"perl /opt/mskcc-vcf2maf/vcf2maf.pl --input-vcf /io_data/{input_vcf} --output-maf /io_data/{output_header0}.maf --tumor-id tumor --normal-id normal --ref-fasta /data/reference/hg19/ucsc.hg19.nochr.fasta --ncbi-build GRCh37 --species homo_sapiens --vep-data /data/reference/vep --vep-path /opt/vep/src/ensembl-vep/ --cache-version 97\"\n\n    output = container.exec_run(command)\n    # print(result.exit_code, result.output.decode('utf-8'))\n    container.stop()\n    container.remove()\n    if \"Error\" in output or \"error\" in output:\n        raise Exception(output)\n\n    output_maf = output_header0+\".maf\"\n    for f in [output_maf]:\n        if not os.path.exists(f):\n            raise FileNotFoundError(f\"{f} is not found\")\n    return output_maf",
          "stage": 1,
          "task_id": null,
          "task_query": null,
          "tool_id": "a7d8ae834c1945bf849e78ff210db831",
          "tool_name": "vcf_to_maf",
          "tool_release": 0,
          "update_time": 1720172180,
          "user_image_path": "/mnt/data/bioinfogpt/tools/images/bioinfogpt/bc_vcf2maf.tar",
          "user_tar_path": null
        },
        {
          "abandon": 0,
          "account": "hpp_test",
          "add_time": 1720171509,
          "cite_count": 0,
          "description": "A tool used to convert a VCF file into a MAF file\n",
          "failed_message": "",
          "mount_point": "/opt",
          "param_input": [
            {
              "description": "Variant Call Format files\n",
              "example": "/mnt/data/bioinfogpt/users/hpp_test/GJX-lung.pass.vcf",
              "name": "input_vcf",
              "param_name": "/io_data/GJX-lung.pass.vcf",
              "system_example": "/mnt/data/bioinfogpt/tools/examples/8301c754110a44c0a9d3bdbe65ef8c55/GJX-lung.pass.vcf",
              "type": "file"
            }
          ],
          "param_output": [
            {
              "description": "Mutation annotation information (MAF) format file\n",
              "example": "/mnt/data/bioinfogpt/users/hpp_test/test.maf",
              "get_from_input": true,
              "get_from_output": true,
              "input_param": "input_vcf",
              "name": "output_maf",
              "param_name": "/io_data/GJX-lung.pass.maf",
              "system_example": "/mnt/data/bioinfogpt/tools/examples/8301c754110a44c0a9d3bdbe65ef8c55/test.maf",
              "type": "file"
            }
          ],
          "review_message": "",
          "review_status": 1,
          "script": "def vcf_to_maf(input_vcf):\n    \n    if not input_vcf.endswith(\".vcf\"):\n        raise ValueError(\"Invalid file name\")\n        \n\n    current_path = os.getcwd()\n    output_header0 = \".\".join(input_vcf.split(\".\")[0:-1])\n\n    client = docker.from_env()\n\n    container_config = {\n    'image': \"vcf_to_maf:17201714964205961\",\n    'command': '/bin/bash',\n    'tty': True,\n    'stdin_open': True,\n    'volumes': {\n        current_path: {\n            'bind': '/io_data',\n            'mode': 'rw'\n        }\n    },\n    'detach': True\n    }\n    container = client.containers.run(**container_config)\n\n    command = f\"perl /opt/mskcc-vcf2maf/vcf2maf.pl --input-vcf /io_data/{input_vcf} --output-maf /io_data/{output_header0}.maf --tumor-id tumor --normal-id normal --ref-fasta /data/reference/hg19/ucsc.hg19.nochr.fasta --ncbi-build GRCh37 --species homo_sapiens --vep-data /data/reference/vep --vep-path /opt/vep/src/ensembl-vep/ --cache-version 97\"\n\n    output = container.exec_run(command)\n    # print(result.exit_code, result.output.decode('utf-8'))\n    container.stop()\n    container.remove()\n    if \"Error\" in output or \"error\" in output:\n        raise Exception(output)\n\n    output_maf = output_header0+\".maf\"\n    for f in [output_maf]:\n        if not os.path.exists(f):\n            raise FileNotFoundError(f\"{f} is not found\")\n    return output_maf",
          "stage": 2,
          "task_id": null,
          "task_query": null,
          "tool_id": "8301c754110a44c0a9d3bdbe65ef8c55",
          "tool_name": "vcf_to_maf",
          "tool_release": 0,
          "update_time": 1720171509,
          "user_image_path": "/mnt/data/bioinfogpt/tools/images/bioinfogpt/bc_vcf2maf.tar",
          "user_tar_path": null
        },
        {
          "abandon": 0,
          "account": "hpp_test",
          "add_time": 1720149657,
          "cite_count": 0,
          "description": "描述",
          "failed_message": null,
          "mount_point": null,
          "param_input": [
            {
              "description": "Variant Call Format files",
              "example": "/mnt/data/bioinfogpt/users/hpp_test/GJX-lung.pass.vcf",
              "name": "vcf_file",
              "system_example": "/mnt/data/bioinfogpt/tools/examples/6bafd9f5f76e4e02b5118f3a6c55632f/GJX-lung.pass.vcf",
              "type": "file"
            }
          ],
          "param_output": [
            {
              "description": "Maf Format files",
              "example": "/mnt/data/bioinfogpt/users/hpp_test/test.maf",
              "name": "maf_file",
              "system_example": "/mnt/data/bioinfogpt/tools/examples/6bafd9f5f76e4e02b5118f3a6c55632f/test.maf",
              "type": "file"
            }
          ],
          "review_message": "",
          "review_status": 3,
          "script": "\nimport os\nimport docker\n\ndef vcf_to_maf(vcf_file):                       # 工具名， 参数列表\n    if not vcf_file.endswith(\".vcf\"):           # 输入文件检查\n        raise ValueError(\"Invalid file name\")\n    \n    current_path = os.getcwd()\n    output_header = vcf_file.split(\".\")[0]       # 输出文件前缀（可选）\n    client = docker.from_env()\n\n    container_config = {                    \n    'image': 'bc_vcf2maf',                  # 使用的镜像\n    'command': '/bin/bash',                 \n    'tty': True,                            \n    'stdin_open': True,                     \n    'volumes': {                            # 挂载主机目录到容器中\n        current_path: {                     # 输入输出文件所在目录（一般不需要修改）\n            'bind': '/io_data',             # 映射到docker中的目录\n            'mode': 'rw'\n        },\n        '/mnt/data/fastq2vcf': {            # docker中要运行的脚本所在目录\n            'bind': '/data',                # 映射到docker中的目录\n            'mode': 'rw'\n        }\n    },\n    'detach': True\n    }\n    container = client.containers.run(**container_config)\n    \n    \n    # docker中的运行脚本的命令，指定输入文件与输出文件等\n    command = f\"perl /opt/mskcc-vcf2maf/vcf2maf.pl --input-vcf /io_data/{vcf_file} --output-maf /io_data/{output_header}.maf --tumor-id tumor --normal-id normal --ref-fasta /data/reference/hg19/ucsc.hg19.nochr.fasta --ncbi-build GRCh37 --species homo_sapiens --vep-data /data/reference/vep --vep-path /opt/vep/src/ensembl-vep/ --cache-version 97\"\n\n\n    output = container.exec_run(command)     \n    # print(result.exit_code, result.output.decode('utf-8'))\n    container.stop()\n    container.remove()\n    if \"Error\" in output or \"error\" in output:\n        raise Exception(output)\n\n    output_file = output_header + \".maf\"                     # 后处理：文件存在检查\n    # output_file1, output_file2 = \"xxx.maf\", \"xxxx.maf\"    \n    for f in [output_file]:                                 # 后处理：文件存在检查\n    # for f in [output_file1, output_file2]\n        if not os.path.exists(f):                           \n            raise FileNotFoundError(f\"{f} is not found\")\n    return output_file                                      # 函数的返回值（输出文件的文件名）\n\nif __name__ == \"__main__\":\n    res = vcf_to_maf(\"GJX-lung.pass.vcf\")\n    print(res)\n",
          "stage": 4,
          "task_id": null,
          "task_query": null,
          "tool_id": "6bafd9f5f76e4e02b5118f3a6c55632f",
          "tool_name": "vcf2maf",
          "tool_release": 1,
          "update_time": 1720149657,
          "user_image_path": "/mnt/data/bioinfogpt/tools/images/bioinfogpt/bc_vcf2maf.tar",
          "user_tar_path": null
        },
        {
          "abandon": 0,
          "account": "hpp_test",
          "add_time": 1720148936,
          "cite_count": 0,
          "description": "描述",
          "failed_message": null,
          "mount_point": null,
          "param_input": [
            {
              "description": "Variant Call Format files",
              "example": "/mnt/data/bioinfogpt/users/hpp_test/GJX-lung.pass.vcf",
              "name": "vcf_file",
              "system_example": "/mnt/data/bioinfogpt/tools/examples/ad5e7f6f805b49dfbf9765a2cb0d859c/GJX-lung.pass.vcf",
              "type": "file"
            }
          ],
          "param_output": [
            {
              "description": "Maf Format files",
              "example": "/mnt/data/bioinfogpt/users/hpp_test/test.maf",
              "name": "maf_file",
              "system_example": "/mnt/data/bioinfogpt/tools/examples/ad5e7f6f805b49dfbf9765a2cb0d859c/test.maf",
              "type": "file"
            }
          ],
          "review_message": "",
          "review_status": 3,
          "script": "\nimport os\nimport docker\n\ndef vcf_to_maf(vcf_file):                       # 工具名， 参数列表\n    if not vcf_file.endswith(\".vcf\"):           # 输入文件检查\n        raise ValueError(\"Invalid file name\")\n    \n    current_path = os.getcwd()\n    output_header = vcf_file.split(\".\")[0]       # 输出文件前缀（可选）\n    client = docker.from_env()\n\n    container_config = {                    \n    'image': 'bc_vcf2maf',                  # 使用的镜像\n    'command': '/bin/bash',                 \n    'tty': True,                            \n    'stdin_open': True,                     \n    'volumes': {                            # 挂载主机目录到容器中\n        current_path: {                     # 输入输出文件所在目录（一般不需要修改）\n            'bind': '/io_data',             # 映射到docker中的目录\n            'mode': 'rw'\n        },\n        '/mnt/data/fastq2vcf': {            # docker中要运行的脚本所在目录\n            'bind': '/data',                # 映射到docker中的目录\n            'mode': 'rw'\n        }\n    },\n    'detach': True\n    }\n    container = client.containers.run(**container_config)\n    \n    \n    # docker中的运行脚本的命令，指定输入文件与输出文件等\n    command = f\"perl /opt/mskcc-vcf2maf/vcf2maf.pl --input-vcf /io_data/{vcf_file} --output-maf /io_data/{output_header}.maf --tumor-id tumor --normal-id normal --ref-fasta /data/reference/hg19/ucsc.hg19.nochr.fasta --ncbi-build GRCh37 --species homo_sapiens --vep-data /data/reference/vep --vep-path /opt/vep/src/ensembl-vep/ --cache-version 97\"\n\n\n    output = container.exec_run(command)     \n    # print(result.exit_code, result.output.decode('utf-8'))\n    container.stop()\n    container.remove()\n    if \"Error\" in output or \"error\" in output:\n        raise Exception(output)\n\n    output_file = output_header + \".maf\"                     # 后处理：文件存在检查\n    # output_file1, output_file2 = \"xxx.maf\", \"xxxx.maf\"    \n    for f in [output_file]:                                 # 后处理：文件存在检查\n    # for f in [output_file1, output_file2]\n        if not os.path.exists(f):                           \n            raise FileNotFoundError(f\"{f} is not found\")\n    return output_file                                      # 函数的返回值（输出文件的文件名）\n\nif __name__ == \"__main__\":\n    res = vcf_to_maf(\"GJX-lung.pass.vcf\")\n    print(res)\n",
          "stage": 4,
          "task_id": null,
          "task_query": null,
          "tool_id": "ad5e7f6f805b49dfbf9765a2cb0d859c",
          "tool_name": "vcf2maf",
          "tool_release": 1,
          "update_time": 1720148936,
          "user_image_path": "/mnt/data/bioinfogpt/tools/images/bioinfogpt/bc_vcf2maf.tar",
          "user_tar_path": null
        },
        {
          "abandon": 0,
          "account": "hpp_test",
          "add_time": 1720148430,
          "cite_count": 0,
          "description": "描述",
          "failed_message": null,
          "mount_point": null,
          "param_input": [
            {
              "description": "Variant Call Format files",
              "example": "/mnt/data/bioinfogpt/users/hpp_test/GJX-lung.pass.vcf",
              "name": "vcf_file",
              "system_example": "/mnt/data/bioinfogpt/tools/examples/39831f320e8845548f384c0a918f2ddb/GJX-lung.pass.vcf",
              "type": "file"
            }
          ],
          "param_output": [
            {
              "description": "Maf Format files",
              "example": "/mnt/data/bioinfogpt/users/hpp_test/test.maf",
              "name": "maf_file",
              "system_example": "/mnt/data/bioinfogpt/tools/examples/39831f320e8845548f384c0a918f2ddb/test.maf",
              "type": "file"
            }
          ],
          "review_message": "",
          "review_status": 1,
          "script": "\nimport os\nimport docker\n\ndef vcf_to_maf(vcf_file):                       # 工具名， 参数列表\n    if not vcf_file.endswith(\".vcf\"):           # 输入文件检查\n        raise ValueError(\"Invalid file name\")\n    \n    current_path = os.getcwd()\n    output_header = vcf_file.split(\".\")[0]       # 输出文件前缀（可选）\n    client = docker.from_env()\n\n    container_config = {                    \n    'image': 'bc_vcf2maf',                  # 使用的镜像\n    'command': '/bin/bash',                 \n    'tty': True,                            \n    'stdin_open': True,                     \n    'volumes': {                            # 挂载主机目录到容器中\n        current_path: {                     # 输入输出文件所在目录（一般不需要修改）\n            'bind': '/io_data',             # 映射到docker中的目录\n            'mode': 'rw'\n        },\n        '/mnt/data/fastq2vcf': {            # docker中要运行的脚本所在目录\n            'bind': '/data',                # 映射到docker中的目录\n            'mode': 'rw'\n        }\n    },\n    'detach': True\n    }\n    container = client.containers.run(**container_config)\n    \n    \n    # docker中的运行脚本的命令，指定输入文件与输出文件等\n    command = f\"perl /opt/mskcc-vcf2maf/vcf2maf.pl --input-vcf /io_data/{vcf_file} --output-maf /io_data/{output_header}.maf --tumor-id tumor --normal-id normal --ref-fasta /data/reference/hg19/ucsc.hg19.nochr.fasta --ncbi-build GRCh37 --species homo_sapiens --vep-data /data/reference/vep --vep-path /opt/vep/src/ensembl-vep/ --cache-version 97\"\n\n\n    output = container.exec_run(command)     \n    # print(result.exit_code, result.output.decode('utf-8'))\n    container.stop()\n    container.remove()\n    if \"Error\" in output or \"error\" in output:\n        raise Exception(output)\n\n    output_file = output_header + \".maf\"                     # 后处理：文件存在检查\n    # output_file1, output_file2 = \"xxx.maf\", \"xxxx.maf\"    \n    for f in [output_file]:                                 # 后处理：文件存在检查\n    # for f in [output_file1, output_file2]\n        if not os.path.exists(f):                           \n            raise FileNotFoundError(f\"{f} is not found\")\n    return output_file                                      # 函数的返回值（输出文件的文件名）\n\nif __name__ == \"__main__\":\n    res = vcf_to_maf(\"GJX-lung.pass.vcf\")\n    print(res)\n",
          "stage": 1,
          "task_id": null,
          "task_query": null,
          "tool_id": "39831f320e8845548f384c0a918f2ddb",
          "tool_name": "vcf2maf",
          "tool_release": 0,
          "update_time": 1720148430,
          "user_image_path": "/mnt/data/bioinfogpt/tools/images/bioinfogpt/bc_vcf2maf.tar",
          "user_tar_path": null
        },
        {
          command: "perl /opt/mskcc-vcf2maf/vcf2maf.pl --input-vcf /io_data/GJX-lung.pass.vcf --output-maf /io_data/GJX-lung.pass.maf --tumor-id tumor --normal-id normal --ref-fasta /data/reference/hg19/ucsc.hg19.nochr.fasta --ncbi-build GRCh37 --species homo_sapiens --vep-data /data/reference/vep --vep-path /opt/vep/src/ensembl-vep/ --cache-version 97",
          "abandon": 0,
          "account": "hpp_test",
          "add_time": 1720074781,
          "cite_count": 0,
          "description": "test2",
          "failed_message": "Use run tool get Failed: 422",
          "mount_point": null,
          "param_input": [
            {
              "description": "test",
              "example": "/mnt/data/bioinfogpt/users/hpp_test/GJX-lung.pass.vcf",
              "name": "input_vcf",
              "param_name": "/io_data/GJX-lung.pass.vcf",
              "system_example": "/mnt/data/bioinfogpt/tools/examples/042717e6755b4c3cb81e5ac2447b6bb8/GJX-lung.pass.vcf",
              "type": "file"
            }
          ],
          "param_output": [
            {
              "description": "test",
              "example": "/mnt/data/bioinfogpt/users/hpp_test/test.maf",
              "get_from_input": true,
              "get_from_output": true,
              "input_param": "input_vcf",
              "name": "output_maf",
              "param_name": "/io_data/GJX-lung.pass.maf",
              "system_example": "/mnt/data/bioinfogpt/tools/examples/042717e6755b4c3cb81e5ac2447b6bb8/test.maf",
              "type": "file"
            }
          ],
          "review_message": null,
          "review_status": 1,
          "script": "\nimport os\nimport docker\n\ndef vcf_to_maf(vcf_file):                       # 工具名， 参数列表\n    if not vcf_file.endswith(\".vcf\"):           # 输入文件检查\n        raise ValueError(\"Invalid file name\")\n\n    current_path = os.getcwd()\n    output_header = vcf_file.split(\".\")[0]       # 输出文件前缀（可选）\n    client = docker.from_env()\n\n    container_config = {                    \n    'image': 'bc_vcf2maf',                  # 使用的镜像\n    'command': '/bin/bash',                 \n    'tty': True,                            \n    'stdin_open': True,                     \n    'volumes': {                            # 挂载主机目录到容器中\n        current_path: {                     # 输入输出文件所在目录（一般不需要修改）\n            'bind': '/io_data',             # 映射到docker中的目录\n            'mode': 'rw'\n        },\n        '/mnt/data/fastq2vcf': {            # docker中要运行的脚本所在目录\n            'bind': '/data',                # 映射到docker中的目录\n            'mode': 'rw'\n        }\n    },\n    'detach': True\n    }\n    container = client.containers.run(**container_config)\n\n\n    # docker中的运行脚本的命令，指定输入文件与输出文件等\n    command = f\"perl /opt/mskcc-vcf2maf/vcf2maf.pl --input-vcf /io_data/{vcf_file} --output-maf /io_data/{output_header}.maf --tumor-id tumor --normal-id normal --ref-fasta /data/reference/hg19/ucsc.hg19.nochr.fasta --ncbi-build GRCh37 --species homo_sapiens --vep-data /data/reference/vep --vep-path /opt/vep/src/ensembl-vep/ --cache-version 97\"\n\n\n    output = container.exec_run(command)     \n    # print(result.exit_code, result.output.decode('utf-8'))\n    container.stop()\n    container.remove()\n    if \"Error\" in output or \"error\" in output:\n        raise Exception(output)\n\n    output_file = output_header + \".maf\"                     # 后处理：文件存在检查\n    # output_file1, output_file2 = \"xxx.maf\", \"xxxx.maf\"    \n    for f in [output_file]:                                 # 后处理：文件存在检查\n    # for f in [output_file1, output_file2]\n        if not os.path.exists(f):                           \n            raise FileNotFoundError(f\"{f} is not found\")\n    return output_file                                      # 函数的返回值（输出文件的文件名）\n\nif __name__ == \"__main__\":\n    res = vcf_to_maf(\"GJX-lung.pass.vcf\")\n    print(res)\n",
          "stage": -1,
          "task_id": null,
          "task_query": null,
          "tool_id": "d67f681efa5448319275f57ba9ef9aec",
          "tool_name": "vcf2maf6",
          "fun_name": "vcf2maf6",
          "tool_release": 0,
          "update_time": 1720769072,
          "user_image_path": "/mnt/data/bioinfogpt/tools/images/bioinfogpt/bc_vcf2maf.tar",
          "user_tar_path": null
        },
        {
          "abandon": 0,
          "account": "hpp_test",
          "add_time": 1720074407,
          "cite_count": 0,
          "description": "描述",
          "failed_message": "",
          "mount_point": null,
          "param_input": [
            {
              "description": "Variant Call Format files",
              "example": "/mnt/data/bioinfogpt/users/hpp_test/GJX-lung.pass.vcf",
              "name": "vcf_file",
              "system_example": "/mnt/data/bioinfogpt/tools/examples/72c8ca3abb4d4cf98d49d76841cb8739/GJX-lung.pass.vcf",
              "type": "file"
            }
          ],
          "param_output": [
            {
              "description": "Maf Format files",
              "example": "/mnt/data/bioinfogpt/users/hpp_test/test.maf",
              "name": "maf_file",
              "system_example": "/mnt/data/bioinfogpt/tools/examples/72c8ca3abb4d4cf98d49d76841cb8739/test.maf",
              "type": "file"
            }
          ],
          "review_message": "",
          "review_status": 1,
          "script": "\nimport os\nimport docker\n\ndef vcf_to_maf(vcf_file):                       # 工具名， 参数列表\n    if not vcf_file.endswith(\".vcf\"):           # 输入文件检查\n        raise ValueError(\"Invalid file name\")\n    \n    current_path = os.getcwd()\n    output_header = vcf_file.split(\".\")[0]       # 输出文件前缀（可选）\n    client = docker.from_env()\n\n    container_config = {                    \n    'image': 'bc_vcf2maf',                  # 使用的镜像\n    'command': '/bin/bash',                 \n    'tty': True,                            \n    'stdin_open': True,                     \n    'volumes': {                            # 挂载主机目录到容器中\n        current_path: {                     # 输入输出文件所在目录（一般不需要修改）\n            'bind': '/io_data',             # 映射到docker中的目录\n            'mode': 'rw'\n        },\n        '/mnt/data/fastq2vcf': {            # docker中要运行的脚本所在目录\n            'bind': '/data',                # 映射到docker中的目录\n            'mode': 'rw'\n        }\n    },\n    'detach': True\n    }\n    container = client.containers.run(**container_config)\n    \n    \n    # docker中的运行脚本的命令，指定输入文件与输出文件等\n    command = f\"perl /opt/mskcc-vcf2maf/vcf2maf.pl --input-vcf /io_data/{vcf_file} --output-maf /io_data/{output_header}.maf --tumor-id tumor --normal-id normal --ref-fasta /data/reference/hg19/ucsc.hg19.nochr.fasta --ncbi-build GRCh37 --species homo_sapiens --vep-data /data/reference/vep --vep-path /opt/vep/src/ensembl-vep/ --cache-version 97\"\n\n\n    output = container.exec_run(command)     \n    # print(result.exit_code, result.output.decode('utf-8'))\n    container.stop()\n    container.remove()\n    if \"Error\" in output or \"error\" in output:\n        raise Exception(output)\n\n    output_file = output_header + \".maf\"                     # 后处理：文件存在检查\n    # output_file1, output_file2 = \"xxx.maf\", \"xxxx.maf\"    \n    for f in [output_file]:                                 # 后处理：文件存在检查\n    # for f in [output_file1, output_file2]\n        if not os.path.exists(f):                           \n            raise FileNotFoundError(f\"{f} is not found\")\n    return output_file                                      # 函数的返回值（输出文件的文件名）\n\nif __name__ == \"__main__\":\n    res = vcf_to_maf(\"GJX-lung.pass.vcf\")\n    print(res)\n",
          "stage": 2,
          "task_id": null,
          "task_query": null,
          "tool_id": "72c8ca3abb4d4cf98d49d76841cb8739",
          "tool_name": "vcf2maf",
          "tool_release": 0,
          "update_time": 1720074407,
          "user_image_path": "/mnt/data/bioinfogpt/tools/images/bioinfogpt/bc_vcf2maf.tar",
          "user_tar_path": null
        },
        {
          "abandon": 0,
          "account": "hpp_test",
          "add_time": 1719991541,
          "cite_count": 0,
          "description": "test2",
          "failed_message": "Use run tool get Failed: 500",
          "mount_point": null,
          "param_input": [
            {
              "description": "Variant Call Format files",
              "example": "/mnt/data/bioinfogpt/users/hpp_test/GJX-lung.pass.vcf",
              "name": "vcf_file",
              "system_example": "/mnt/data/bioinfogpt/tools/examples/d98102051cf741b2881a450e3faf0675/GJX-lung.pass.vcf",
              "type": "file"
            }
          ],
          "param_output": [
            {
              "description": "Maf Format files",
              "example": "/mnt/data/bioinfogpt/users/hpp_test/test.maf",
              "name": "maf_file",
              "system_example": "/mnt/data/bioinfogpt/tools/examples/d98102051cf741b2881a450e3faf0675/test.maf",
              "type": "file"
            }
          ],
          "review_message": null,
          "review_status": 1,
          "script": "\nimport os\nimport docker\n\ndef vcf_to_maf(vcf_file):                       # 工具名， 参数列表\n    if not vcf_file.endswith(\".vcf\"):           # 输入文件检查\n        raise ValueError(\"Invalid file name\")\n\n    current_path = os.getcwd()\n    output_header = vcf_file.split(\".\")[0]       # 输出文件前缀（可选）\n    client = docker.from_env()\n\n    container_config = {                    \n    'image': 'bc_vcf2maf',                  # 使用的镜像\n    'command': '/bin/bash',                 \n    'tty': True,                            \n    'stdin_open': True,                     \n    'volumes': {                            # 挂载主机目录到容器中\n        current_path: {                     # 输入输出文件所在目录（一般不需要修改）\n            'bind': '/io_data',             # 映射到docker中的目录\n            'mode': 'rw'\n        },\n        '/mnt/data/fastq2vcf': {            # docker中要运行的脚本所在目录\n            'bind': '/data',                # 映射到docker中的目录\n            'mode': 'rw'\n        }\n    },\n    'detach': True\n    }\n    container = client.containers.run(**container_config)\n\n\n    # docker中的运行脚本的命令，指定输入文件与输出文件等\n    command = f\"perl /opt/mskcc-vcf2maf/vcf2maf.pl --input-vcf /io_data/{vcf_file} --output-maf /io_data/{output_header}.maf --tumor-id tumor --normal-id normal --ref-fasta /data/reference/hg19/ucsc.hg19.nochr.fasta --ncbi-build GRCh37 --species homo_sapiens --vep-data /data/reference/vep --vep-path /opt/vep/src/ensembl-vep/ --cache-version 97\"\n\n\n    output = container.exec_run(command)     \n    # print(result.exit_code, result.output.decode('utf-8'))\n    container.stop()\n    container.remove()\n    if \"Error\" in output or \"error\" in output:\n        raise Exception(output)\n\n    output_file = output_header + \".maf\"                     # 后处理：文件存在检查\n    # output_file1, output_file2 = \"xxx.maf\", \"xxxx.maf\"    \n    for f in [output_file]:                                 # 后处理：文件存在检查\n    # for f in [output_file1, output_file2]\n        if not os.path.exists(f):                           \n            raise FileNotFoundError(f\"{f} is not found\")\n    return output_file                                      # 函数的返回值（输出文件的文件名）\n\nif __name__ == \"__main__\":\n    res = vcf_to_maf(\"GJX-lung.pass.vcf\")\n    print(res)\n",
          "stage": 2,
          "task_id": null,
          "task_query": null,
          "tool_id": "d98102051cf741b2881a450e3faf0675",
          "tool_name": "vcf2maf2",
          "tool_release": 0,
          "update_time": 1720509885,
          "user_image_path": "/mnt/data/bioinfogpt/tools/images/bioinfogpt/bc_vcf2maf.tar",
          "user_tar_path": null
        }
      ],
      "message": "success",
      "status": 1000001
    });
    return;
  }
  api_request({
    type: 'get',
    url: '/api/v2/biogpt/tools/admin/',
    data: rq,
    crud_name: '管理员查看工具列表',
    success: func
  });
};
export const post_biogpt_tools_admin_review = (rq, func)=>{
  if(isDEV){
    func({
      "message": "success",
      "status": 1000001
    });
    return;
  }
  api_request({
    type: 'post',
    url: '/api/v2/biogpt/tools/admin/review/',
    data: rq,
    crud_name: '管理员审核工具, 用户具有C及以上权限, 只能审核质检完成且待审核的工具',
    success: func
  });
};
export const crud_biogpt_tools = (method, rq, func)=>{
  if(isDEV){
    func({
      "data": {
        "account": "hpp_test",
        "description": "描述",
        "param_input": [
          {
            "description": "xxx",
            "example": "1123",
            "name": "input1",
            "system_example": "1123",
            "type": "string"
          }
        ],
        "param_output": [
          {
            "description": "xxx",
            "example": "1123",
            "name": "output1",
            "system_example": "1123",
            "type": "string"
          }
        ],
        "script": "import os",
        "tool_id": "d98102051cf741b2881a450e3faf0675",
        "tool_name": "vcf2maf",
        "user_image_path": "/mnt/data/bioinfogpt/tools/images/bioinfogpt/bc_vcf2maf.tar"
      },
      "message": "success",
      "status": 1000001
    });
    return;
  }
  api_request({
    type: method,
    url: '/api/v2/biogpt/tools/',
    data: rq,
    crud_name: '新建/更新工具',
    success: func
  });
};


export const post_biogpt_tools_release = (data, func)=>{
  if(isDEV){
    func({
      "message": "success",
      "status": 1000001
    });
    return;
  }
  api_request({
    data,
    type: 'post',
    url: '/api/v2/biogpt/tools/release/',
    // data: rq,
    crud_name: '上线工具',
    success: func
  });
};

export const post_biogpt_tools_verify = (data, func)=>{
  if(isDEV){
    func({
      "message": "success",
      "status": 1000001
    });
    return;
  }
  api_request({
    data,
    type: 'post',
    url: '/api/v2/biogpt/tools/verify/',
    // data: rq,
    crud_name: '验证工具命名',
    success: func
  });
};
//aftergo创建分享码
export const post_biogpt_subscribe_share = (rq, func)=>{
  api_request({
    type: 'POST',
    url: '/api/v2/biogpt/aftergo/subscribe/share/',
    data: rq,
    crud_name: 'aftergo创建分享码',
    success: func
  });
};
//aftergo文献上传创建分享码
export const post_biogpt_upload_share = (rq, func)=>{
  api_request({
    type: 'POST',
    url: '/api/v2/biogpt/aftergo/paper/share/',
    data: rq,
    crud_name: 'aftergo文献上传创建分享码',
    success: func
  });
};
//aftergo查看文献状态
export const get_biogpt_upload_status = (rq, func)=>{
  api_request({
    type: 'GET',
    url: '/api/v2/biogpt/aftergo/paper/upload/',
    data: rq,
    crud_name: 'aftergo查看文献状态',
    success: func
  });
};
//aftergo分享码获取订阅详情
export const post_biogpt_skip_subscribe_info = (rq, func)=>{
  api_request({
    type: 'POST',
    url: '/api/v2/biogpt/skip/aftergo/share/subscribe/info/',
    data: rq,
    crud_name: 'aftergo分享码获取订阅详情',
    success: func
  });
};
//aftergo分享码获取一次推送内容
export const post_biogpt_skip_subscribe_share_push_info = (rq, func)=>{
  api_request({
    type: 'POST',
    url: '/api/v2/biogpt/skip/aftergo/share/push/info/',
    data: rq,
    crud_name: 'aftergo分享码获取一次推送内容',
    success: func
  });
};
//aftergo获取上传的文章解读（用户）
export const post_biogpt_paper_upload_info = (rq, func)=>{
  if(isDEV){
    let res = {
      "data": {
        "abstract": "Understanding transcriptional responses to chemical perturbations is central to drug discovery, but exhaustive experimental screening of disease-compound combinations is unfeasible. To overcome this limitation, here we introduce PRnet, a perturbation-conditioned deep generative model that predicts transcriptional responses to novel chemical perturbations that have never experimentally perturbed at bulk and single-cell levels. Evaluations indicate that PRnet outperforms alternative methods in predicting responses across novel compounds, pathways, and cell lines. PRnet enables gene-level response interpretation and in-silico drug screening for diseases based on gene signatures. PRnet further identiﬁes and experimentally validates novel compound candidates against small cell lung cancer and colorectal cancer. Lastly, PRnet generates a large-scale integration atlas of perturbation proﬁles, covering 88 cell lines, 52 tissues, and various compound libraries. PRnet provides a robust and scalable candidate recommendation workﬂow and successfully recommends drug candidates for 233 diseases. Overall, PRnet is an effective and valuable tool for gene-based therapeutics screening.",
        "abstract_cn": "理解化学扰动下的转录反应是药物发现的核心，但对疾病-化合物组合进行详尽的实验筛选是不可行的。为此，我们提出了PRnet，这是一种基于条件扰动的深度生成模型，能够预测在整体和单细胞水平上从未实验扰动过的新型化学扰动下的转录反应。评估表明，PRnet在预测新型化合物、通路和细胞系的反应方面优于其他方法。PRnet支持基于基因特征的疾病药物筛选，并针对小细胞肺癌和结直肠癌鉴定和实验验证了新型化合物候选。此外，PRnet生成了涵盖88种细胞系、52种组织和多种化合物库的大规模扰动图谱集成，为233种疾病成功推荐了候选药物。总体而言，PRnet是基于基因治疗筛选的有效工具。",
        "article_date": null,
        "article_type": null,
        "audio_status": 0,
        "audio_url": null,
        "authors": "Xiaoning Qi,Lianhe Zhao,Chenyu Tian,Yueyue Li,Zhen-Lin Chen,Peipei Huo,Runsheng Chen,Xiaodong Liu,Baoping Wan,Shengyong Yang,Yi Zhao",
        "doi": "10.1038/s41467-024-53457-1",
        "embedding": -1,
        "jif": "NA",
        "journal_issn": null,
        "journal_issue": null,
        "journal_title": "Nature Communications",
        "journal_volume": null,
        "key_innovation": "本文的核心创新点（key_innovation）可系统归纳如下：\n\n1. **深度生成模型的开发**  \n   - 提出PRnet这一新型深度生成模型，能够预测新型化学化合物（包括未见过的化合物、通路和细胞系）对转录反应的扰动效应，支持从批量RNA-seq到单细胞分辨率的高通量筛选数据分析。\n\n2. **多维度预测能力**  \n   - 实现跨场景泛化：可预测未知化合物、细胞系及剂量条件下的基因表达变化，自动捕捉潜在空间中化合物、剂量和细胞类型特异性异质性。  \n   - 支持单细胞级异质性解析，精准识别大规模筛选中的差异响应。\n\n3. **方法学创新**  \n   - 开发可扩展的Perturb-adapter模块，直接处理任意化合物的SMILES表示。  \n   - 提出反向签名筛选方法（基于基因特征）和伪剂量轨迹分析技术。  \n   - 通过扰动解码器复用扰动嵌入，整合化学与生物学上下文信息。  \n   - 引入噪声增强和四种严格数据分割策略，确保模型鲁棒性。\n\n4. **大规模数据整合与应用**  \n   - 构建包含2500多万个扰动表达谱的整合图谱，建立可扩展的药物推荐流程。  \n   - 成功识别多种疾病的潜在治疗化合物（如小细胞肺癌、结直肠癌、NASH、克罗恩病等），为233种复杂疾病提供候选药物。  \n   - 融合多源数据（bulk RNA-seq、sci-Plex3、单细胞数据）及六种化合物库，通过技术重复确保统计可重复性。\n\n5. **评估体系**  \n   - 设计多指标综合评估框架，全面衡量模型在预测精度、泛化能力和生物学相关性方面的性能。\n\n综上，PRnet通过创新的模型架构、严格的方法设计和大规模应用验证，实现了从化学扰动预测到疾病治疗发现的完整计算解决方案，显著推进了计算药物发现领域的发展。",
        "key_innovation_cn": null,
        "keywords": "deep learning,drug discovery,transcriptional response prediction",
        "keywords_cn": "深度学习,药物发现,转录反应预测",
        "limitations": "通过对各章节limitations的整合分析，本研究存在以下主要局限性：\n\n1. 数据依赖性局限\n- 模型性能高度依赖训练数据质量（#3、#4、#6）\n- 需要相同细胞类型的未扰动数据作为对照（#7）\n- 样本量不足问题（#4、#9、#11）：涉及结直肠癌（14种细胞系）、SCLC（5细胞系）、儿科AML（13例患者）等\n- 使用公共数据集可能引入原始研究的偏差（#11）\n\n2. 模型架构限制\n- 仅能处理未配对的扰动转录组数据（#7）\n- SMILES编码可能无法完整表征复杂分子特征（#10）\n- 反向签名范式适用性有限（#10）\n- 缺乏对表型效应的考量（#10）\n\n3. 生物学验证不足\n- 主要依赖计算机模拟（#5）\n- 实验验证仅限特定细胞系（#4）\n- 人类癌细胞系的遗传不稳定性影响结果（#8）\n- 部分疾病（如NASH）缺乏明确靶点（#9）\n\n4. 应用场景限制\n- 对罕见/特殊化学扰动预测效果有限（#3）\n- 需更多临床前/临床研究验证（#5）\n- 筛选方法受基因特征定义限制（#4）\n\n5. 技术性限制\n- 部分化合物因观测不足（<5次）或SMILES解析问题被排除（#11）\n- 许可限制禁止未经允许的衍生材料共享（#1）\n\n这些局限性反映了从计算方法到生物学验证的多层次挑战，建议后续研究通过扩大样本量、改进分子表征方法、加强跨数据集验证以及开展更多实验研究来突破当前限制。",
        "limitations_cn": null,
        "llm_keywords": "drug discovery,deep learning,transcriptional response prediction",
        "llm_keywords_cn": "药物发现,深度学习,转录反应预测",
        "organization": "Research Center for Ubiquitous Computing Systems, Institute of Computing Technology, Chinese Academy of Sciences,University of Chinese Academy of Sciences,Department of Biotherapy, Cancer Center and State Key Laboratory of Biotherapy, West China Hospital, Sichuan University,Key Laboratory of Intelligent Information Processing of Chinese Academy of Sciences (CAS), Institute of Computing Technology, Chinese Academy of Sciences,Luoyang Institute of Information Technology Industries,West China Hospital, Sichuan University,University of Chinese Academy Sciences",
        "paper_no": 1545,
        "parse_info": {
          "page_count": 14,
          "page_num": 14,
          "parse_step": 5
        },
        "pdf_url": "https://www.vipaper.com/store/upload/7fd6689bc9b1460eb939e816d8a3f988/7fd6689bc9b1460eb939e816d8a3f988.pdf",
        "pmcid": null,
        "pmid": "NA",
        "pub_date": "Fri, 11 Oct 2024 00:00:00 GMT",
        "pub_year": "2024",
        "research_method": "### 完整研究方法（Research Method）汇总：\n\n1. **核心模型架构**  \n   - 开发基于深度学习的**PRnet模型**（核算法），采用**编码器-解码器架构的深度生成模型**，包含三个关键组件：  \n     - **Perturb-adapter**：处理化学扰动输入  \n     - **Perturb-encoder**：捕获功能拓扑信息  \n     - **Perturb-decoder**：预测转录谱  \n   - 框架基础：**变分自编码器（VAE）**，使用高斯负对数似然损失函数训练。\n\n2. **输入数据处理**  \n   - 化学扰动表示：采用**SMILES字符串编码**和剂量信息作为输入。  \n   - 基因表达数据：扩展978个标志基因至12,328个基因的转录谱，计算扰动倍数变化和平均倍数变化。  \n   - 数据预处理：  \n     - 清洗L1000、sci-Plex3、SCLC等数据集（删除无效SMILES、填充缺失值、筛选高变异基因等）。  \n     - 构建未扰动-扰动样本对。  \n\n3. **训练与验证方法**  \n   - **训练数据**：两个化合物库（包含bulk和单细胞高通量筛选数据）及六个筛选库。  \n   - **评估策略**：  \n     - 四种数据分割方式（随机/化合物/细胞系/通路分割）结合5折交叉验证。  \n     - 性能指标：Pearson相关系数、决定系数（R²）、Kolmogorov-Smirnov检验。  \n   - **分析工具**：  \n     - **t-SNE**用于伪剂量轨迹可视化。  \n     - **GSEA（基因集富集分析）**和计算机筛选流程。  \n     - 基于富集分数的化合物排名。  \n\n4. **实验验证**  \n   - **体外验证**：MTT实验验证化合物活性（技术重复3次）。  \n   - **计算验证**：虚拟高通量筛选预测多细胞系转录谱，结合单细胞数据（如Sci-plex3）。  \n\n5. **应用流程**  \n   - 通过PRnet预测化学扰动响应→生成基因表达变化→筛选化合物→实验验证（MTT/GSEA）→富集分析排名。  \n\n### 方法亮点：\n- **多模态数据整合**：结合SMILES化学编码、bulk/single-cell转录组、实验数据。  \n- **鲁棒性验证**：交叉验证策略覆盖数据分割多样性（化合物/细胞系/通路）。  \n- **端到端预测**：从化学输入到转录输出，最终实现化合物活性筛选与排名。",
        "research_method_cn": null,
        "source": 1,
        "status": 4,
        "summary": "本文介绍了PRnet（一种基于变分自编码器框架的深度生成模型），该模型通过整合化合物结构（SMILES编码）和未扰动转录谱作为输入，能够预测新型化学扰动下的转录响应，适用于批量及单细胞水平的药物发现研究。PRnet包含三大核心组件：Perturb-adapter（化合物编码模块）、Perturb-encoder（潜在空间映射模块）和Perturb-decoder（扰动后表达生成模块），通过高斯似然分布预测基因表达变化。\n\n研究采用多组学数据（包括978个标志基因的bulk RNA-seq、sci-Plex3数据集、SCLC数据集和儿科AML单细胞数据）进行训练与验证，使用Pearson相关性和R2分数等指标评估性能，显著优于线性模型和MLP基线。模型展现出三大核心能力：（1）精准预测未见过的化合物/细胞系的转录谱变化；（2）解析单细胞高通量筛选的异质性反应；（3）通过基因集富集分析（GSEA）评估化合物疗效。\n\n在应用层面，PRnet成功实现：① 虚拟筛选生成超过2500万扰动表达谱，涵盖FDA药物、天然化合物等五大类库；② 识别577个候选药物用于233种疾病治疗（包括小细胞肺癌和结直肠癌的特效化合物）；③ 预测儿科AML患者化疗后的临床相关转录反应。所有数据和代码已公开，研究受中国多项基金资助，成果发表于《Nature Communications》。",
        "summary_brief": "PRnet是一种基于深度学习的化学扰动转录反应预测模型，支持新型药物发现",
        "summary_cn": null,
        "title": "Predicting transcriptional responses to novel chemical perturbations using deep generative model for drug discovery",
        "title_cn": "使用深度生成模型预测新型化学扰动下的转录反应以用于药物发现",
        "upload_status": -3,
        "audio_parse_info": {
          "audio_index": null,
          "audio_url": "https://www.vipaper.com/store/audio/bab7d112d7b0424d8efeaa72b079f974/final.mp3",
          "status": 1,
          "sum_nu": 65
        },
        "video_parse_info": {
          "add_time": "2026-01-28 17:03:38",
          "outline": null,
          "pdf_img": null,
          "pdf_page": [
            "https://www.vipaper.com/store/upload/7fd6689bc9b1460eb939e816d8a3f988/pages/page_1.png",
            "https://www.vipaper.com/store/upload/7fd6689bc9b1460eb939e816d8a3f988/pages/page_2.png",
            "https://www.vipaper.com/store/upload/7fd6689bc9b1460eb939e816d8a3f988/pages/page_3.png",
            "https://www.vipaper.com/store/upload/7fd6689bc9b1460eb939e816d8a3f988/pages/page_4.png",
            "https://www.vipaper.com/store/upload/7fd6689bc9b1460eb939e816d8a3f988/pages/page_5.png",
            "https://www.vipaper.com/store/upload/7fd6689bc9b1460eb939e816d8a3f988/pages/page_6.png",
            "https://www.vipaper.com/store/upload/7fd6689bc9b1460eb939e816d8a3f988/pages/page_7.png",
            "https://www.vipaper.com/store/upload/7fd6689bc9b1460eb939e816d8a3f988/pages/page_8.png",
            "https://www.vipaper.com/store/upload/7fd6689bc9b1460eb939e816d8a3f988/pages/page_9.png",
            "https://www.vipaper.com/store/upload/7fd6689bc9b1460eb939e816d8a3f988/pages/page_10.png",
            "https://www.vipaper.com/store/upload/7fd6689bc9b1460eb939e816d8a3f988/pages/page_11.png",
            "https://www.vipaper.com/store/upload/7fd6689bc9b1460eb939e816d8a3f988/pages/page_12.png",
            "https://www.vipaper.com/store/upload/7fd6689bc9b1460eb939e816d8a3f988/pages/page_13.png",
            "https://www.vipaper.com/store/upload/7fd6689bc9b1460eb939e816d8a3f988/pages/page_14.png"
          ],
          "ppt_page": null,
          "step": -1,
          "update_time": "2026-01-28 17:06:06"
        },
        "video_status": -1,
        "video_url": null
      },
      "message": "success",
      "status": 1000001
    };
    func(res);
    return;
  }
  api_request({
    type: 'POST',
    base_url: LocationOrigin + '/api/v2/biogpt/aftergo/paper/upload/info/',
    url: '',
    data: rq,
    crud_name: 'aftergo分享码获取文章详情',
    success: func
  });
};
export const post_audio_next = (rq, func)=>{
  api_request({
    type: 'POST',
    base_url: LocationOrigin + '/api/v2/biogpt/aftergo/paper/audio/next/',
    url: '',
    data: rq,
    crud_name: 'aftergo获取下一段音频',
    success: func
  });
};

//aftergo分享码获取文章详情
export const post_biogpt_subscribe_share_paper = (rq, func)=>{
  if(isDEV){
    let res = require('@/json/share');
    // let ppt = require('@/json/ppt-payload');
    // res.data.video_parse_info.ppt_page = ppt;
    func(res);
    return;
  }
  api_request({
    type: 'POST',
    base_url: LocationOrigin + '/api/v2/biogpt/skip/aftergo/share/paper/',
    url: '',
    data: rq,
    crud_name: 'aftergo分享码获取文章详情',
    success: func
  });
};
//aftergo获取文章详情
export const get_biogpt_aftergo_paper = (rq, func)=>{
  api_request({
    type: 'GET',
    url: ' /api/v2/biogpt/aftergo/paper/',
    data: rq,
    crud_name: 'aftergo获取文章详情',
    success: func
  });
};
//新建订阅 更新订阅
export const p_biogpt_subscribe = (method, rq, func)=>{

  api_request({
    type: method,
    url: '/api/v2/biogpt/subscribe/',
    data: rq,
    crud_name: '新建或更新订阅',
    success: func
  });
};

//aftergo获取推送列表
export const get_biogpt_push_list = ( func)=>{
  api_request({
    type: 'get',
    url: '/api/v2/biogpt/aftergo/mine/push/list/',
    crud_name: 'aftergo获取推送列表',
    success: func
  });
};
//aftergo查看推送详情
export const post_biogpt_push_info = (data, func)=>{
  api_request({
    data,
    type: 'post',
    url: '/api/v2/biogpt/aftergo/push/info/',
    crud_name: 'aftergo查看推送详情',
    success: func
  });
};
//aftergo生成视频video或者音频audio
export const post_biogpt_pubmed_media = (media, data, func)=>{
  api_request({
    data,
    type: 'post',
    url: '/api/v2/biogpt/aftergo/paper/'+ media +'/',
    crud_name: 'aftergo生成' + media,
    success: func
  });
};

//我的订阅
export const get_biogpt_subscribe = ( func)=>{
  api_request({
    type: 'get',
    url: '/api/v2/biogpt/subscribe/',
    crud_name: '我的订阅',
    success: func
  });
};
//上传列表
export const get_biogpt_upload = ( func)=>{
  api_request({
    type: 'get',
    url: '/api/v2/biogpt/aftergo/paper/upload/list/',
    crud_name: '上传列表',
    success: func
  });
};
//上传pdf
export const post_biogpt_upload_pdf_file = (data, func)=>{
  api_request({
    data,
    type: 'post',
    url: '/api/v2/biogpt/aftergo/paper/upload/file/',
    crud_name: '上传pdf',
    success: func
  });
};
//上传pdf提交解析
export const post_biogpt_upload_pdf = (data, func)=>{
  api_request({
    data,
    type: 'post',
    url: '/api/v2/biogpt/aftergo/paper/upload/',
    crud_name: '上传pdf',
    success: func
  });
};
//aftergo问答
export const post_biogpt_chat_message = (data, func)=>{
  let stream = true;
  let url = '/api/v2/biogpt/aftergo/chat/message/';
  if(stream){
    data.stream = true;
    // get_answer_stream('/api/v2/biogpt/skip/aftergo/chat/message/', data, func);
    get_answer_stream(url, data, func);
    return;
  }
  api_request({
    data,
    type: 'post',
    url: url,
    crud_name: 'aftergo问答',
    success: func
  });
};
// 积分相关
export const get_biogpt_user_info = (func)=>{
  api_request({
    type: 'get',
    url: '/api/v2/biogpt/aftergo/user/info/',
    crud_name: 'aftergo个人信息（积分）',
    success: func
  });
};
export const get_biogpt_admin_points = (func)=>{
  api_request({
    type: 'get',
    url: '/api/v2/biogpt/aftergo/admin/points/list/',
    crud_name: 'aftergo用户积分列表（管理员）',
    success: func
  });
};
export const post_biogpt_admin_points = (data, func)=>{
  api_request({
    data,
    type: 'post',
    url: '/api/v2/biogpt/aftergo/admin/points/',
    crud_name: 'aftergo充值积分（管理员）',
    success: func
  });
};
export const get_biogpt_admin_points_records = (func)=>{
  api_request({
    type: 'get',
    url: '/api/v2/biogpt/aftergo/points/records/',
    crud_name: 'aftergo查看积分变更记录',
    success: func
  });
};
export const get_biogpt_admin_points_daily = (func)=>{
  api_request({
    type: 'get',
    url: '/api/v2/biogpt/aftergo/points/daily/',
    crud_name: 'aftergo查询每日积分消耗',
    success: func
  });
};
// 4、查看兑换码记录列表（管路员）
// http://dms.gene.ac/dev/api/info/?api_no=c27f59d6299f478a893a86ecd85b7f60
export const get_biogpt_admin_points_coupon_record= (data, func)=>{
  api_request({
    data,
    type: 'get',
    url: '/api/v2/biogpt/aftergo/points/coupon/record/',
    crud_name: '查看兑换码记录列表',
    success: func
  });
};
// 1、创建兑换码（管理员） 成功返回兑换码，和有效期截止日期
// http://dms.gene.ac/dev/api/info/?api_no=45c669a050a543729ebe04de0db42d7c
export const post_biogpt_admin_points_coupon= (data, func)=>{
  api_request({
    data,
    type: 'POST',
    url: '/api/v2/biogpt/aftergo/points/coupon/',
    crud_name: '创建兑换码',
    success: func
  });
};

// 2、作废兑换码（管理员）
// http://dms.gene.ac/dev/api/info/?api_no=66100ca647e647afb09aa39ae65b9eb2
export const post_biogpt_admin_points_coupon_void= (data, func)=>{
  api_request({
    data,
    type: 'POST',
    url: '/api/v2/biogpt/aftergo/points/coupon/void/',
    crud_name: '作废兑换码',
    success: func
  });
};

// 3、核销兑换码
// http://dms.gene.ac/dev/api/info/?api_no=82d2989f325d414680f31c037112027b
export const post_biogpt_admin_points_coupon_redeem= (data, func)=>{
  api_request({
    data,
    type: 'POST',
    url: '/api/v2/biogpt/aftergo/points/coupon/redeem/',
    crud_name: '核销兑换码',
    success: func
  });
};


//查看系统关键词
export const get_biogpt_subscribe_keywords = ( func)=>{
  api_request({
    type: 'get',
    url: '/api/v2/biogpt/aftergo/keywords/',
    crud_name: '查看系统关键词',
    success: func
  });
};
//删除订阅
export const delete_biogpt_subscribe = (data, func)=>{
  api_request({
    data,
    type: 'delete',
    url: '/api/v2/biogpt/subscribe/',
    crud_name: '删除订阅',
    success: func
  });
};
export const endpoint_127 = 'http://127.0.0.1';
export const endpoint_v = `${endpoint_127}:8011`;
export const endpoint_wangtao = `${endpoint_127}:8001`;
//黄威http://127.0.0.1:8011
export const post_check_tool_tcm_api = (rq, func, isDEV1)=>{
  if(isDEV1 === undefined) isDEV1 = isDEV;
  if(isDEV1){
    func({
      "code": "def vcf_to_maf(input-vcf):\n    \n    if not input-vcf.endswith(\".vcf\"):\n        raise ValueError(\"Invalid file name\")\n        \n\n    current_path = os.getcwd()\n    output_header0 = \".\".join(/io_data.split(\".\")[0:-1])\n\n    client = docker.from_env()\n\n    container_config = {\n    'image': \"vcf_to_maf:17201666423881028\",\n    'command': '/bin/bash',\n    'tty': True,\n    'stdin_open': True,\n    'volumes': {\n        current_path: {\n            'bind': '/io_data',\n            'mode': 'rw'\n        },\n        \"\": {\n            'bind': '/opt',\n            'mode': 'rw'\n        }\n    },\n    'detach': True\n    }\n    container = client.containers.run(**container_config)\n\n    command = f\"perl /opt/mskcc-vcf2maf/vcf2maf.pl --input-vcf /io_data/{input-vcf} --output-maf /io_data/{output_header0}.maf --tumor-id tumor --normal-id normal --ref-fasta /data/reference/hg19/ucsc.hg19.nochr.fasta --ncbi-build GRCh37 --species homo_sapiens --vep-data /data/reference/vep --vep-path /opt/vep/src/ensembl-vep/ --cache-version 97\"\n\n    output = container.exec_run(command)\n    # print(result.exit_code, result.output.decode('utf-8'))\n    container.stop()\n    container.remove()\n    if \"Error\" in output or \"error\" in output:\n        raise Exception(output)\n\n    output-maf = output_header0+\".maf\"\n    for f in [output-maf]:\n        if not os.path.exists(f):\n            raise FileNotFoundError(f\"{f} is not found\")\n    return output-maf",
      "error": "",
      "example": "```python\noutput-maf = vcf_to_maf(\"GJX-lung.pass.vcf\")\n\"\"\"\noutput-maf:\"GJX-lung.pass.maf\"\n\"\"\"\n```\n",
      "image_name": "vcf_to_maf:17201666423881028",
      "message": "success",
      "script_path": ""
    });
    return;
  }

  let url = endpoint_v + '/check_tool/';
  api_request({
    url: url,
    type: 'post',
    data: rq,
    crud_name: '本API端点 `/check_tool/` 旨在分析传入的Python代码片段，并提取其中的函数参数和返回值。',
    success: func
  });
};

//孙靖博http://127.0.0.1:8011
export const post_retriever = (rq, func)=>{
  let url = endpoint_v + '/retriever';
  api_request({
    url: url,
    type: 'post',
    data: rq,
    crud_name: '本API端点 `/check_tool/` 旨在分析传入的Python代码片段，并提取其中的函数参数和返回值。',
    success: func
  });
};
//王涛http://127.0.0.1:8001
export const post_search_pubmed = ( res, func)=>{
  if(isDEV){
    func({
      "code": 200,
      "response": {
        "message": "查询成功",
        "total_records": 10,
        "data": [
          {
            "PMID": 37683442,
            "Journal": "Respiratory medicine and research. 2023 Nov;84():101028.",
            "Abstract": "The ETAPES program is a national telemedicine experiment conducted in France between 2018 and 2023 to investigate whether home non-invasive ventilation (NIV) telemonitoring improves healthcare pathways in patients with chronic respiratory failure (CRF) and impacts healthcare organization. The program provides a combination of therapeutic education and NIV telemonitoring with data processed by an algorithm generating alerts. The TELVENT study objective was to analyze the evolution of ventilation quality in patients included in the ETAPES program.",
            "Paper_pdf": null,
            "Publish_Date": "2023-11-01",
            "Disease": null,
            "Publication_Year": null,
            "NIHMS_ID": null,
            "Title": "Home NIV treatment quality in patients with chronic respiratory failure having participated to the French nationwide telemonitoring experimental program (The TELVENT study).",
            "First_Author": "Sandrine Pontier-Marchandise",
            "Ref_id": 7,
            "Authors": "Sandrine Pontier-Marchandise,Sandrine Pontier-Marchandise,Sandrine Pontier-Marchandise,Sandrine Pontier-Marchandise,Sandrine Pontier-Marchandise,Sandrine Pontier-Marchandise,Sandrine Pontier-Marchandise,Sandrine Pontier-Marchandise,",
            "DOI": "10.1016/j.resmer.2023.101028",
            "Affiliation": "Department of Respiratory Medicine, Larrey Hospital, Toulouse University Hospital, Toulouse, France. Electronic address: pontier.s@chu-toulouse.fr.",
            "Create_Date": "2024-07-07",
            "Modify_time": "2023-12-15",
            "Citation": null,
            "PMCID": null
          },
          {
            "PMID": 38062597,
            "Journal": "Journal of the College of Physicians and Surgeons--Pakistan : JCPSP. 2023 Dec;33(12):1405-1409.",
            "Abstract": "To investigate the effect of the haemoglobin, albumin, lymphocyte, and platelet (HALP) score (Haemoglobin, Albumin, Lymphocyte, Platelet count) on survival as a new prognostic factor in metastatic bladder cancer.",
            "Paper_pdf": null,
            "Publish_Date": "2023-12-01",
            "Disease": null,
            "Publication_Year": null,
            "NIHMS_ID": null,
            "Title": "HALP Score as a New Prognostic Factor for Patients with Metastatic Bladder Cancer.",
            "First_Author": "Omer Acar",
            "Ref_id": 8,
            "Authors": "Omer Acar,Omer Acar,Omer Acar,Omer Acar,Omer Acar,Omer Acar,",
            "DOI": "10.29271/jcpsp.2023.12.1405",
            "Affiliation": "Department of Medical Oncology, Celal Bayar University, Manisa, Turkey.",
            "Create_Date": "2024-07-07",
            "Modify_time": "2023-12-15",
            "Citation": null,
            "PMCID": null
          },
          {
            "PMID": 38092797,
            "Journal": "Scientific reports. 2023 Dec;13(1):22135.",
            "Abstract": "The Arctic is subjected to all-encompassing disruptions in marine ecosystems caused by anthropogenic warming. To provide reliable estimates of how future changes will affect the ecosystems, knowledge of Arctic marine ecosystem responses to past environmental variability beyond the instrumental era is essential. Here, we present a novel approach on how to evaluate the state of benthic marine biotic conditions during the deglacial and Holocene period on the Northeast Greenland shelf. Benthic foraminiferal species were assigned traits (e.g., oxygen tolerance, food preferences) aiming to identify past faunal changes as a response to external forcing mechanisms. This approach was applied on sediment cores from offshore Northeast Greenland. We performed numerical rate-of-change detection to determine significant changes in the benthic foraminiferal traits. That way, the significant abrupt trait changes can be assessed across sites, providing a better understanding of the impact of climate drivers on the traits. Our results demonstrate that during the last ~ 14,000 years, bottom water oxygen is the main factor affecting the variability in the benthic foraminiferal faunas in this area. Our results show that significant changes in the traits correspond to drastic climate perturbations. Specifically, the deglacial-Holocene transition and mid-Holocene warm period exhibited significant change, with several trait turnovers.",
            "Paper_pdf": null,
            "Publish_Date": "2023-12-01",
            "Disease": null,
            "Publication_Year": null,
            "NIHMS_ID": null,
            "Title": "Response of Arctic benthic foraminiferal traits to past environmental changes.",
            "First_Author": "Katrine Elnegaard Hansen",
            "Ref_id": 9,
            "Authors": "Katrine Elnegaard Hansen,Katrine Elnegaard Hansen,Katrine Elnegaard Hansen,",
            "DOI": "10.1038/s41598-023-47603-w",
            "Affiliation": "Paleoceanography and Paleoclimate Group, Department of Geoscience, Arctic Research Center and iClimate Center, Aarhus University, Aarhus, Denmark. keha@geus.dk.",
            "Create_Date": "2024-07-07",
            "Modify_time": "2023-12-15",
            "Citation": null,
            "PMCID": null
          },
          {
            "PMID": 17111134,
            "Journal": "Applied microbiology and biotechnology. 2023 Dec;107(Suppl 1):1-7.",
            "Abstract": "We introduced a strategy for preparing a carbohydrate microarray and demonstrated its utility for characterizing carbohydrate binding and activities. We isolated the lipopolysaccharide (LPS) components from different bacteria and explored the possibility of immobilizing these glycoconjugates on a high-binding polystyrene plate. Carbohydrate-specific combination was examined by observing the binding of the blood group B analogic LPS O-polysaccharide from Escherichia coli on the high-binding polystyrene plate and anti-B from a broad spectra antibody of human blood serum. Strong binding of antibodies was screened, as it was evident that relative response value is two times higher than control. The hybridization results indicated that this method is a reliable technique for the detection of human intestinal bacteria and is expected to be applied in diagnostics and seroepidemiology.",
            "Paper_pdf": null,
            "Publish_Date": "2023-12-01",
            "Disease": null,
            "Publication_Year": null,
            "NIHMS_ID": null,
            "Title": "Fabrication and application of carbohydrate microarray for analyzing human serum antibody-carbohydrate interaction.",
            "First_Author": "Gang-Liang Huang",
            "Ref_id": 11,
            "Authors": "Gang-Liang Huang,Gang-Liang Huang,Gang-Liang Huang,Gang-Liang Huang,",
            "DOI": "10.1007/s00253-006-0723-9",
            "Affiliation": "State Key Laboratory of Microbial Technology (SKLMT), Shandong University, Jinan, Shandong, 250100, People's Republic of China. hgl226@126.com.",
            "Create_Date": "2024-07-07",
            "Modify_time": "2023-12-17",
            "Citation": null,
            "PMCID": null
          },
          {
            "PMID": 33764285,
            "Journal": "Cranio : the journal of craniomandibular practice. 2024 Jan;42(1):48-54.",
            "Abstract": "To evaluate the prevalence of sleep bruxism, related factors, and quality of life of preschool children and their families.",
            "Paper_pdf": null,
            "Publish_Date": "2024-01-01",
            "Disease": null,
            "Publication_Year": null,
            "NIHMS_ID": null,
            "Title": "Factors associated with preschool children's sleep bruxism.",
            "First_Author": "Soraia Veloso da Costa",
            "Ref_id": 20,
            "Authors": "Soraia Veloso da Costa,Soraia Veloso da Costa,Soraia Veloso da Costa,Soraia Veloso da Costa,Soraia Veloso da Costa,Soraia Veloso da Costa,",
            "DOI": "10.1080/08869634.2021.1903663",
            "Affiliation": "University Center, UniFTC, Salvador, Bahia, Brazil.",
            "Create_Date": "2024-07-07",
            "Modify_time": "2023-12-26",
            "Citation": null,
            "PMCID": null
          },
          {
            "PMID": 38190799,
            "Journal": "Journal of the National Comprehensive Cancer Network : JNCCN. 2024 Jan;():1-14.",
            "Abstract": "We previously showed the 21-gene breast recurrence score (RS) has lower prognostic accuracy for non-Hispanic Black (NHB) compared with non-Hispanic White (NHW) women with estrogen receptor (ER)-positive/HER2-negative breast cancer. The purpose of this study was to determine the clinical validity of the RS for predicting chemotherapy benefit as recommended in the current NCCN Guidelines for Breast Cancer among women from diverse racial/ethnic groups.",
            "Paper_pdf": null,
            "Publish_Date": "2024-01-01",
            "Disease": null,
            "Publication_Year": null,
            "NIHMS_ID": null,
            "Title": "Reduction in Breast Cancer Death With Adjuvant Chemotherapy Among US Women According to Race, Ethnicity, and the 21-Gene Recurrence Score.",
            "First_Author": "Hsiao-Ching Huang",
            "Ref_id": 35,
            "Authors": "Hsiao-Ching Huang,Hsiao-Ching Huang,Hsiao-Ching Huang,Hsiao-Ching Huang,Hsiao-Ching Huang,Hsiao-Ching Huang,Hsiao-Ching Huang,Hsiao-Ching Huang,",
            "DOI": "10.6004/jnccn.2023.7077",
            "Affiliation": "1Department of Pharmacy Systems, Outcomes and Policy, University of Illinois College of Pharmacy, Chicago, Illinois.",
            "Create_Date": "2024-07-07",
            "Modify_time": "2024-01-09",
            "Citation": null,
            "PMCID": null
          },
          {
            "PMID": 34047283,
            "Journal": "Studies in health technology and informatics. 2023 Dec;311():25-43.",
            "Abstract": "Electronic patient data use and handling are critical issues in terms of privacy, confidentiality, security, and the Health Insurance Portability and Accountability Act (HIPAA) regulations. The risks associated with electronic patient data are not limited to identity theft but rather include a person's social, economic, and psychological well-being. However, there have not been many studies that have focused on the associated risk factors that could lead to these situations. This paper identifies those risks related to electronic patient data breaches by means of a grounded theory approach and develops a systemic risk management plan that enables engineering managers and risk managers to more effectively and efficiently overcome risks associated with electronic patient data. Purpose: The purpose of this paper is to identify the risks associated with electronic patient data breach using a grounded theory approach and also to recommend a set of guidelines to support a better, effective, and efficient system and thereby overcome these risks. Patients and methods: No patients were involved either to participate in this study or any of their opinions are reflected with this research.",
            "Paper_pdf": null,
            "Publish_Date": "2023-12-01",
            "Disease": null,
            "Publication_Year": null,
            "NIHMS_ID": null,
            "Title": "Systemic Risk Management Plan for Electronic Medical Records (EMR): Why and How?",
            "First_Author": "Ziniya Zahedi",
            "Ref_id": 41,
            "Authors": "Ziniya Zahedi,Ziniya Zahedi,Ziniya Zahedi,",
            "DOI": "10.3233/SHTI200016",
            "Affiliation": "Georgetown University Law Center, Washington, DC, USA.",
            "Create_Date": "2024-07-07",
            "Modify_time": "2024-01-15",
            "Citation": null,
            "PMCID": null
          },
          {
            "PMID": 37891782,
            "Journal": "Brain sciences. 2023 Oct;13(10):249-257.",
            "Abstract": "To date, no one has prospectively evaluated yoga intervention-induced changes in brain structure or function in adults with acquired brain injuries (ABI). Thus, this study was conducted to test the feasibility of acquiring neuroimaging data from adults with ABI before and after a yoga intervention.",
            "Paper_pdf": null,
            "Publish_Date": "2023-10-01",
            "Disease": null,
            "Publication_Year": null,
            "NIHMS_ID": null,
            "Title": "Feasibility of Acquiring Neuroimaging Data from Adults with Acquired Brain Injuries before and after a Yoga Intervention.",
            "First_Author": "Jaclyn A Stephens",
            "Ref_id": 68,
            "Authors": "Jaclyn A Stephens,Jaclyn A Stephens,Jaclyn A Stephens,Jaclyn A Stephens,Jaclyn A Stephens,Jaclyn A Stephens,Jaclyn A Stephens,",
            "DOI": "10.3390/brainsci13101413",
            "Affiliation": "Department of Occupational Therapy, Colorado State University, Fort Collins, CO 80524, USA.",
            "Create_Date": "2024-07-07",
            "Modify_time": "2024-02-10",
            "Citation": null,
            "PMCID": null
          },
          {
            "PMID": 38224751,
            "Journal": "Chemosphere. 2024 Mar;351():141209.",
            "Abstract": "Perfluorooctanoic acid (PFOA) is an emerging pollutant that is non-biodegradable and presents severe environmental and human health risks. In this study, we present an effective and mild approach for PFOA degradation that involves the use of nitrogen-doped carbon foam anchored with nanoscale zero-valent iron (nZVI@NCF) to activate low concentration peroxymonosulfate (PMS) for the treatment. The nZVI@NCF/PMS system efficiently removed 84.4% of PFOA (2.4 μM). The active sites of nZVI@NCF including Fe",
            "Paper_pdf": null,
            "Publish_Date": "2024-03-01",
            "Disease": null,
            "Publication_Year": null,
            "NIHMS_ID": null,
            "Title": "Degradation and mechanism of PFOA by peroxymonosulfate activated by nitrogen-doped carbon foam-anchored nZVI in aqueous solutions.",
            "First_Author": "Changyu Li",
            "Ref_id": 72,
            "Authors": "Changyu Li,Changyu Li,Changyu Li,Changyu Li,Changyu Li,Changyu Li,Changyu Li,Changyu Li,Changyu Li,Changyu Li,",
            "DOI": "10.1016/j.chemosphere.2024.141209",
            "Affiliation": "State Key Laboratory of Pollution Control and Resource Reuse, Key Laboratory of Surficial Geochemistry, Ministry of Education, School of Earth Sciences and Engineering, Hydrosciences Department, Nanjing University, Nanjing, 210023, China. Electronic address: carryleeee@163.com.",
            "Create_Date": "2024-07-07",
            "Modify_time": "2024-02-13",
            "Citation": null,
            "PMCID": null
          },
          {
            "PMID": 37887431,
            "Journal": "Cartilage. 2024 Mar;15(1):37-46.",
            "Abstract": "To determine the clinical, safety, and radiological outcomes after biological resurfacing arthroplasty for the treatment of osteoarthritis (OA) of one or more joints of the midtarsal joint complex.",
            "Paper_pdf": null,
            "Publish_Date": "2024-03-01",
            "Disease": null,
            "Publication_Year": null,
            "NIHMS_ID": null,
            "Title": "Prospective Outcomes of a Biological Resurfacing Arthroplasty with Fascia Lata Autograft (BioJoint) for the Treatment of Osteoarthritis of the Midtarsal Joint Complex.",
            "First_Author": "Jari Dahmen",
            "Ref_id": 74,
            "Authors": "Jari Dahmen,Jari Dahmen,Jari Dahmen,",
            "DOI": "10.1177/19476035231206740",
            "Affiliation": "Department of Orthopedic Surgery and Sports Medicine, Amsterdam Movement Sciences, Amsterdam UMC, Location AMC, University of Amsterdam, Amsterdam, The Netherlands.",
            "Create_Date": "2024-07-07",
            "Modify_time": "2024-02-14",
            "Citation": null,
            "PMCID": null
          }
        ]
      }
    });
    return;
  }
  api_request({
    data: res,
    type: 'POST',
    url: endpoint_wangtao + '/get_pubmeds/',
    success: func,
    api_info: {api_name: "检索pubmed", api_prefix: ""}
  })
};
//aftergo 获取paper列表
export const get_aftergo_paper_list = (data, func)=>{
  api_request({
    data,
    type: 'get',
    url: '/api/v2/biogpt/aftergo/paper/list/',
    success: func,
    api_info: {api_name: "aftergo 获取paper列表", api_prefix: ""}
  })
};
export const jumpToDetail = (upload_no, paper_no)=>{
  if(upload_no && paper_no) window.location.href = ('/push/paper/?paper_no=' + paper_no + '&upload_no=' + upload_no);
};
//paper 查看我的解析记录
export const get_aftergo_paper_upload_mine = (func)=>{
  api_request({
    type: 'get',
    url: '/api/v2/biogpt/aftergo/paper/upload/mine/',
    success: func,
    api_info: {api_name: "查看上传列表（用户） ", api_prefix: ""}
  })
};
export const getMediaText = (status)=>{
  if(status === 0) return '未创建';
  if(status === 1) return '生成中';
  if(status === -1) return '生成失败';
  if(status === 2) return '生成成功';
  return status;
};